if (typeof lazySizes !== 'function') {
	/*! lazysizes - v4.1.8 */
	!(function(a, b) {
		var c = b(a, a.document);
		(a.lazySizes = c), 'object' == typeof module && module.exports && (module.exports = c);
	})(window, function(a, b) {
		'use strict';
		if (b.getElementsByClassName) {
			var c,
				d,
				e = b.documentElement,
				f = a.Date,
				g = a.HTMLPictureElement,
				h = 'addEventListener',
				i = 'getAttribute',
				j = a[h],
				k = a.setTimeout,
				l = a.requestAnimationFrame || k,
				m = a.requestIdleCallback,
				n = /^picture$/i,
				o = ['load', 'error', 'lazyincluded', '_lazyloaded'],
				p = {},
				q = Array.prototype.forEach,
				r = function(a, b) {
					return p[b] || (p[b] = new RegExp('(\\s|^)' + b + '(\\s|$)')), p[b].test(a[i]('class') || '') && p[b];
				},
				s = function(a, b) {
					r(a, b) || a.setAttribute('class', (a[i]('class') || '').trim() + ' ' + b);
				},
				t = function(a, b) {
					var c;
					(c = r(a, b)) && a.setAttribute('class', (a[i]('class') || '').replace(c, ' '));
				},
				u = function(a, b, c) {
					var d = c ? h : 'removeEventListener';
					c && u(a, b),
						o.forEach(function(c) {
							a[d](c, b);
						});
				},
				v = function(a, d, e, f, g) {
					var h = b.createEvent('Event');
					return e || (e = {}), (e.instance = c), h.initEvent(d, !f, !g), (h.detail = e), a.dispatchEvent(h), h;
				},
				w = function(b, c) {
					var e;
					!g && (e = a.picturefill || d.pf)
						? (c && c.src && !b[i]('srcset') && b.setAttribute('srcset', c.src), e({ reevaluate: !0, elements: [b] }))
						: c && c.src && (b.src = c.src);
				},
				x = function(a, b) {
					return (getComputedStyle(a, null) || {})[b];
				},
				y = function(a, b, c) {
					for (c = c || a.offsetWidth; c < d.minSize && b && !a._lazysizesWidth; ) (c = b.offsetWidth), (b = b.parentNode);
					return c;
				},
				z = (function() {
					var a,
						c,
						d = [],
						e = [],
						f = d,
						g = function() {
							var b = f;
							for (f = d.length ? e : d, a = !0, c = !1; b.length; ) b.shift()();
							a = !1;
						},
						h = function(d, e) {
							a && !e ? d.apply(this, arguments) : (f.push(d), c || ((c = !0), (b.hidden ? k : l)(g)));
						};
					return (h._lsFlush = g), h;
				})(),
				A = function(a, b) {
					return b
						? function() {
								z(a);
						  }
						: function() {
								var b = this,
									c = arguments;
								z(function() {
									a.apply(b, c);
								});
						  };
				},
				B = function(a) {
					var b,
						c = 0,
						e = d.throttleDelay,
						g = d.ricTimeout,
						h = function() {
							(b = !1), (c = f.now()), a();
						},
						i =
							m && g > 49
								? function() {
										m(h, { timeout: g }), g !== d.ricTimeout && (g = d.ricTimeout);
								  }
								: A(function() {
										k(h);
								  }, !0);
					return function(a) {
						var d;
						(a = !0 === a) && (g = 33), b || ((b = !0), (d = e - (f.now() - c)), d < 0 && (d = 0), a || d < 9 ? i() : k(i, d));
					};
				},
				C = function(a) {
					var b,
						c,
						d = 99,
						e = function() {
							(b = null), a();
						},
						g = function() {
							var a = f.now() - c;
							a < d ? k(g, d - a) : (m || e)(e);
						};
					return function() {
						(c = f.now()), b || (b = k(g, d));
					};
				};
			!(function() {
				var b,
					c = {
						lazyClass: 'lazyload',
						loadedClass: 'lazyloaded',
						loadingClass: 'lazyloading',
						preloadClass: 'lazypreload',
						errorClass: 'lazyerror',
						autosizesClass: 'lazyautosizes',
						srcAttr: 'data-src',
						srcsetAttr: 'data-srcset',
						sizesAttr: 'data-sizes',
						minSize: 40,
						customMedia: {},
						init: !0,
						expFactor: 1.5,
						hFac: 0.8,
						loadMode: 2,
						loadHidden: !0,
						ricTimeout: 0,
						throttleDelay: 125,
					};
				d = a.lazySizesConfig || a.lazysizesConfig || {};
				for (b in c) b in d || (d[b] = c[b]);
				(a.lazySizesConfig = d),
					k(function() {
						d.init && F();
					});
			})();
			var D = (function() {
					var g,
						l,
						m,
						o,
						p,
						y,
						D,
						F,
						G,
						H,
						I,
						J,
						K = /^img$/i,
						L = /^iframe$/i,
						M = 'onscroll' in a && !/(gle|ing)bot/.test(navigator.userAgent),
						N = 0,
						O = 0,
						P = 0,
						Q = -1,
						R = function(a) {
							P--, (!a || P < 0 || !a.target) && (P = 0);
						},
						S = function(a) {
							return (
								null == J && (J = 'hidden' == x(b.body, 'visibility')),
								J || ('hidden' != x(a.parentNode, 'visibility') && 'hidden' != x(a, 'visibility'))
							);
						},
						T = function(a, c) {
							var d,
								f = a,
								g = S(a);
							for (F -= c, I += c, G -= c, H += c; g && (f = f.offsetParent) && f != b.body && f != e; )
								(g = (x(f, 'opacity') || 1) > 0) &&
									'visible' != x(f, 'overflow') &&
									((d = f.getBoundingClientRect()), (g = H > d.left && G < d.right && I > d.top - 1 && F < d.bottom + 1));
							return g;
						},
						U = function() {
							var a,
								f,
								h,
								j,
								k,
								m,
								n,
								p,
								q,
								r,
								s,
								t,
								u = c.elements;
							if ((o = d.loadMode) && P < 8 && (a = u.length)) {
								for (f = 0, Q++; f < a; f++)
									if (u[f] && !u[f]._lazyRace)
										if (!M || (c.prematureUnveil && c.prematureUnveil(u[f]))) aa(u[f]);
										else if (
											(((p = u[f][i]('data-expand')) && (m = 1 * p)) || (m = O),
											r ||
												((r = !d.expand || d.expand < 1 ? (e.clientHeight > 500 && e.clientWidth > 500 ? 500 : 370) : d.expand),
												(c._defEx = r),
												(s = r * d.expFactor),
												(t = d.hFac),
												(J = null),
												O < s && P < 1 && Q > 2 && o > 2 && !b.hidden ? ((O = s), (Q = 0)) : (O = o > 1 && Q > 1 && P < 6 ? r : N)),
											q !== m && ((y = innerWidth + m * t), (D = innerHeight + m), (n = -1 * m), (q = m)),
											(h = u[f].getBoundingClientRect()),
											(I = h.bottom) >= n &&
												(F = h.top) <= D &&
												(H = h.right) >= n * t &&
												(G = h.left) <= y &&
												(I || H || G || F) &&
												(d.loadHidden || S(u[f])) &&
												((l && P < 3 && !p && (o < 3 || Q < 4)) || T(u[f], m)))
										) {
											if ((aa(u[f]), (k = !0), P > 9)) break;
										} else
											!k &&
												l &&
												!j &&
												P < 4 &&
												Q < 4 &&
												o > 2 &&
												(g[0] || d.preloadAfterLoad) &&
												(g[0] || (!p && (I || H || G || F || 'auto' != u[f][i](d.sizesAttr)))) &&
												(j = g[0] || u[f]);
								j && !k && aa(j);
							}
						},
						V = B(U),
						W = function(a) {
							var b = a.target;
							if (b._lazyCache) return void delete b._lazyCache;
							R(a), s(b, d.loadedClass), t(b, d.loadingClass), u(b, Y), v(b, 'lazyloaded');
						},
						X = A(W),
						Y = function(a) {
							X({ target: a.target });
						},
						Z = function(a, b) {
							try {
								a.contentWindow.location.replace(b);
							} catch (c) {
								a.src = b;
							}
						},
						$ = function(a) {
							var b,
								c = a[i](d.srcsetAttr);
							(b = d.customMedia[a[i]('data-media') || a[i]('media')]) && a.setAttribute('media', b), c && a.setAttribute('srcset', c);
						},
						_ = A(function(a, b, c, e, f) {
							var g, h, j, l, o, p;
							(o = v(a, 'lazybeforeunveil', b)).defaultPrevented ||
								(e && (c ? s(a, d.autosizesClass) : a.setAttribute('sizes', e)),
								(h = a[i](d.srcsetAttr)),
								(g = a[i](d.srcAttr)),
								f && ((j = a.parentNode), (l = j && n.test(j.nodeName || ''))),
								(p = b.firesLoad || ('src' in a && (h || g || l))),
								(o = { target: a }),
								s(a, d.loadingClass),
								p && (clearTimeout(m), (m = k(R, 2500)), u(a, Y, !0)),
								l && q.call(j.getElementsByTagName('source'), $),
								h ? a.setAttribute('srcset', h) : g && !l && (L.test(a.nodeName) ? Z(a, g) : (a.src = g)),
								f && (h || l) && w(a, { src: g })),
								a._lazyRace && delete a._lazyRace,
								t(a, d.lazyClass),
								z(function() {
									var b = a.complete && a.naturalWidth > 1;
									(p && !b) ||
										(b && s(a, 'ls-is-cached'),
										W(o),
										(a._lazyCache = !0),
										k(function() {
											'_lazyCache' in a && delete a._lazyCache;
										}, 9)),
										'lazy' == a.loading && P--;
								}, !0);
						}),
						aa = function(a) {
							if (!a._lazyRace) {
								var b,
									c = K.test(a.nodeName),
									e = c && (a[i](d.sizesAttr) || a[i]('sizes')),
									f = 'auto' == e;
								((!f && l) || !c || (!a[i]('src') && !a.srcset) || a.complete || r(a, d.errorClass) || !r(a, d.lazyClass)) &&
									((b = v(a, 'lazyunveilread').detail), f && E.updateElem(a, !0, a.offsetWidth), (a._lazyRace = !0), P++, _(a, b, f, e, c));
							}
						},
						ba = C(function() {
							(d.loadMode = 3), V();
						}),
						ca = function() {
							3 == d.loadMode && (d.loadMode = 2), ba();
						},
						da = function() {
							if (!l) {
								if (f.now() - p < 999) return void k(da, 999);
								(l = !0), (d.loadMode = 3), V(), j('scroll', ca, !0);
							}
						};
					return {
						_: function() {
							(p = f.now()),
								(c.elements = b.getElementsByClassName(d.lazyClass)),
								(g = b.getElementsByClassName(d.lazyClass + ' ' + d.preloadClass)),
								j('scroll', V, !0),
								j('resize', V, !0),
								a.MutationObserver
									? new MutationObserver(V).observe(e, { childList: !0, subtree: !0, attributes: !0 })
									: (e[h]('DOMNodeInserted', V, !0), e[h]('DOMAttrModified', V, !0), setInterval(V, 999)),
								j('hashchange', V, !0),
								['focus', 'mouseover', 'click', 'load', 'transitionend', 'animationend', 'webkitAnimationEnd'].forEach(function(a) {
									b[h](a, V, !0);
								}),
								/d$|^c/.test(b.readyState) ? da() : (j('load', da), b[h]('DOMContentLoaded', V), k(da, 2e4)),
								c.elements.length ? (U(), z._lsFlush()) : V();
						},
						checkElems: V,
						unveil: aa,
						_aLSL: ca,
					};
				})(),
				E = (function() {
					var a,
						c = A(function(a, b, c, d) {
							var e, f, g;
							if (((a._lazysizesWidth = d), (d += 'px'), a.setAttribute('sizes', d), n.test(b.nodeName || '')))
								for (e = b.getElementsByTagName('source'), f = 0, g = e.length; f < g; f++) e[f].setAttribute('sizes', d);
							c.detail.dataAttr || w(a, c.detail);
						}),
						e = function(a, b, d) {
							var e,
								f = a.parentNode;
							f &&
								((d = y(a, f, d)),
								(e = v(a, 'lazybeforesizes', { width: d, dataAttr: !!b })),
								e.defaultPrevented || ((d = e.detail.width) && d !== a._lazysizesWidth && c(a, f, e, d)));
						},
						f = function() {
							var b,
								c = a.length;
							if (c) for (b = 0; b < c; b++) e(a[b]);
						},
						g = C(f);
					return {
						_: function() {
							(a = b.getElementsByClassName(d.autosizesClass)), j('resize', g);
						},
						checkElems: g,
						updateElem: e,
					};
				})(),
				F = function() {
					F.i || ((F.i = !0), E._(), D._());
				};
			return (c = { cfg: d, autoSizer: E, loader: D, init: F, uP: w, aC: s, rC: t, hC: r, fire: v, gW: y, rAF: z });
		}
	});
	/*! ls.rias.min.ks - v4.1.8 */
	!(function(a, b) {
		var c = function() {
			b(a.lazySizes), a.removeEventListener('lazyunveilread', c, !0);
		};
		(b = b.bind(null, a, a.document)),
			'object' == typeof module && module.exports
				? b(require('lazysizes'))
				: a.lazySizes
				? c()
				: a.addEventListener('lazyunveilread', c, !0);
	})(window, function(a, b, c) {
		'use strict';
		function d(b, c) {
			var d,
				e,
				f,
				g,
				h = a.getComputedStyle(b);
			(e = b.parentNode),
				(g = { isPicture: !(!e || !m.test(e.nodeName || '')) }),
				(f = function(a, c) {
					var d = b.getAttribute('data-' + a);
					if (!d) {
						var e = h.getPropertyValue('--ls-' + a);
						e && (d = e.trim());
					}
					if (d) {
						if ('true' == d) d = !0;
						else if ('false' == d) d = !1;
						else if (l.test(d)) d = parseFloat(d);
						else if ('function' == typeof j[a]) d = j[a](b, d);
						else if (q.test(d))
							try {
								d = JSON.parse(d);
							} catch (a) {}
						g[a] = d;
					} else a in j && 'function' != typeof j[a] ? (g[a] = j[a]) : c && 'function' == typeof j[a] && (g[a] = j[a](b, d));
				});
			for (d in j) f(d);
			return (
				c.replace(p, function(a, b) {
					b in g || f(b, !0);
				}),
				g
			);
		}
		function e(a, b) {
			var c = [],
				d = function(a, c) {
					return k[typeof b[c]] ? b[c] : a;
				};
			return (
				(c.srcset = []),
				b.absUrl && (s.setAttribute('href', a), (a = s.href)),
				(a = ((b.prefix || '') + a + (b.postfix || '')).replace(p, d)),
				b.widths.forEach(function(d) {
					var e = b.widthmap[d] || d,
						f = b.aspectratio || b.ratio,
						g = !b.aspectratio && j.traditionalRatio,
						h = { u: a.replace(n, e).replace(o, f ? (g ? Math.round(d * f) : Math.round(d / f)) : ''), w: d };
					c.push(h), c.srcset.push((h.c = h.u + ' ' + d + 'w'));
				}),
				c
			);
		}
		function f(a, c, d) {
			var f = 0,
				g = 0,
				h = d;
			if (a) {
				if ('container' === c.ratio) {
					for (f = h.scrollWidth, g = h.scrollHeight; !((f && g) || h === b); )
						(h = h.parentNode), (f = h.scrollWidth), (g = h.scrollHeight);
					f && g && (c.ratio = g / f);
				}
				(a = e(a, c)),
					(a.isPicture = c.isPicture),
					u && 'IMG' == d.nodeName.toUpperCase() ? d.removeAttribute(i.srcsetAttr) : d.setAttribute(i.srcsetAttr, a.srcset.join(', ')),
					Object.defineProperty(d, '_lazyrias', { value: a, writable: !0 });
			}
		}
		function g(a, b) {
			var e = d(a, b);
			return j.modifyOptions.call(a, { target: a, details: e, detail: e }), c.fire(a, 'lazyriasmodifyoptions', e), e;
		}
		function h(a) {
			return (
				a.getAttribute(a.getAttribute('data-srcattr') || j.srcAttr) ||
				a.getAttribute(i.srcsetAttr) ||
				a.getAttribute(i.srcAttr) ||
				a.getAttribute('data-pfsrcset') ||
				''
			);
		}
		var i,
			j,
			k = { string: 1, number: 1 },
			l = /^\-*\+*\d+\.*\d*$/,
			m = /^picture$/i,
			n = /\s*\{\s*width\s*\}\s*/i,
			o = /\s*\{\s*height\s*\}\s*/i,
			p = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi,
			q = /^\[.*\]|\{.*\}$/,
			r = /^(?:auto|\d+(px)?)$/,
			s = b.createElement('a'),
			t = b.createElement('img'),
			u = 'srcset' in t && !('sizes' in t),
			v = !!a.HTMLPictureElement && !u;
		!(function() {
			var b,
				d = function() {},
				e = {
					prefix: '',
					postfix: '',
					srcAttr: 'data-src',
					absUrl: !1,
					modifyOptions: d,
					widthmap: {},
					ratio: !1,
					traditionalRatio: !1,
					aspectratio: !1,
				};
			(i = (c && c.cfg) || a.lazySizesConfig),
				i || ((i = {}), (a.lazySizesConfig = i)),
				i.supportsType ||
					(i.supportsType = function(a) {
						return !a;
					}),
				i.rias || (i.rias = {}),
				'widths' in (j = i.rias) ||
					((j.widths = []),
					(function(a) {
						for (var b, c = 0; !b || b < 3e3; ) (c += 5), c > 30 && (c += 1), (b = 36 * c), a.push(b);
					})(j.widths));
			for (b in e) b in j || (j[b] = e[b]);
		})(),
			addEventListener(
				'lazybeforesizes',
				function(a) {
					if (a.detail.instance == c) {
						var b, d, e, k, l, m, o, p, q, s, t, u, x;
						if (
							((b = a.target),
							a.detail.dataAttr &&
								!a.defaultPrevented &&
								!j.disabled &&
								(q = b.getAttribute(i.sizesAttr) || b.getAttribute('sizes')) &&
								r.test(q))
						) {
							if (((d = h(b)), (e = g(b, d)), (t = n.test(e.prefix) || n.test(e.postfix)), e.isPicture && (k = b.parentNode)))
								for (l = k.getElementsByTagName('source'), m = 0, o = l.length; m < o; m++)
									(t || n.test((p = h(l[m])))) && (f(p, e, l[m]), (u = !0));
							t || n.test(d)
								? (f(d, e, b), (u = !0))
								: u && ((x = []), (x.srcset = []), (x.isPicture = !0), Object.defineProperty(b, '_lazyrias', { value: x, writable: !0 })),
								u && (v ? b.removeAttribute(i.srcAttr) : 'auto' != q && ((s = { width: parseInt(q, 10) }), w({ target: b, detail: s })));
						}
					}
				},
				!0
			);
		var w = (function() {
			var d = function(a, b) {
					return a.w - b.w;
				},
				e = function(a) {
					var b,
						c,
						d = a.length,
						e = a[d - 1],
						f = 0;
					for (f; f < d; f++)
						if (((e = a[f]), (e.d = e.w / a.w), e.d >= a.d)) {
							!e.cached &&
								(b = a[f - 1]) &&
								b.d > a.d - 0.13 * Math.pow(a.d, 2.2) &&
								((c = Math.pow(b.d - 0.6, 1.6)), b.cached && (b.d += 0.15 * c), b.d + (e.d - a.d) * c > a.d && (e = b));
							break;
						}
					return e;
				},
				f = function(a, b) {
					var d;
					return (
						!a._lazyrias &&
							c.pWS &&
							(d = c.pWS(a.getAttribute(i.srcsetAttr || ''))).length &&
							(Object.defineProperty(a, '_lazyrias', { value: d, writable: !0 }),
							b && a.parentNode && (d.isPicture = 'PICTURE' == a.parentNode.nodeName.toUpperCase())),
						a._lazyrias
					);
				},
				g = function(b) {
					var d = a.devicePixelRatio || 1,
						e = c.getX && c.getX(b);
					return Math.min(e || d, 2.4, d);
				},
				h = function(b, c) {
					var h, i, j, k, l, m;
					if (((l = b._lazyrias), l.isPicture && a.matchMedia))
						for (i = 0, h = b.parentNode.getElementsByTagName('source'), j = h.length; i < j; i++)
							if (f(h[i]) && !h[i].getAttribute('type') && (!(k = h[i].getAttribute('media')) || (matchMedia(k) || {}).matches)) {
								l = h[i]._lazyrias;
								break;
							}
					return (!l.w || l.w < c) && ((l.w = c), (l.d = g(b)), (m = e(l.sort(d)))), m;
				},
				j = function(d) {
					if (d.detail.instance == c) {
						var e,
							g = d.target;
						if (!u && (a.respimage || a.picturefill || lazySizesConfig.pf)) return void b.removeEventListener('lazybeforesizes', j);
						('_lazyrias' in g || (d.detail.dataAttr && f(g, !0))) &&
							(e = h(g, d.detail.width)) &&
							e.u &&
							g._lazyrias.cur != e.u &&
							((g._lazyrias.cur = e.u),
							(e.cached = !0),
							c.rAF(function() {
								g.setAttribute(i.srcAttr, e.u), g.setAttribute('src', e.u);
							}));
					}
				};
			return v ? (j = function() {}) : addEventListener('lazybeforesizes', j), j;
		})();
	});
}

var onSale = false;
var soldOut = false;
var priceVaries = false;
var images = [];
var firstVariant = {};

// Fix the confict suggestion search in Debut theme
if (typeof theme !== 'undefined' && theme.hasOwnProperty('settings')) theme.settings.predictiveSearchEnabled = false;
// Override Settings
var boostPFSFilterConfig = {
	general: {
        openMultiLevelByDefault: [0],
		limit: boostPFSThemeConfig.custom.products_per_page,
		/* Optional */
		loadProductFirst: true,
		// Placeholder
		showPlaceholderProductList: true,
		placeholderProductPerRow: 3,
		placeholderProductGridItemClass:
			'boost-pfs-filter-product-item boost-pfs-filter-product-item-grid boost-pfs-filter-grid-width-3 boost-pfs-filter-grid-width-mb-2',
		enableOTP: true,
		separateRefineByFromFilter: true,
		//filterTreeMobileStyle: 'style2', // 'style2', 'style3',
		equal_height: boostPFSThemeConfig.custom.equal_height,
		cropImagePossitionEqualHeight: boostPFSThemeConfig.custom.equal_height_crop_image_position,
		defaultDisplay: boostPFSThemeConfig.custom.product_item_type,
	},
	selector: {
		otpButtons: '.boost-pfs-filter-product-item-image',
	},
};

(function() {
	BoostPFS.inject(this);

	/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	function prepareShopifyData(data) {
		// Displaying price base on the policy of Shopify, have to multiple by 100
		soldOut = !data.available; // Check a product is out of stock
		onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Convert images to array
		images = data.images_info;
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		return data;
	}

	/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	/************************** BUILD PRODUCT LIST **************************/
	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function(data) {
		if (!data) data = this.data;
		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;
		// Customize API data to get the Shopify data
		data = prepareShopifyData(data);
		// Add Custom class
		var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
		var saleClass = onSale ? boostPFSTemplate.saleClass : '';
		itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
		itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
		// Add Grid Width class
		itemHtml = itemHtml.replace(/{{gridWidthClass}}/g, buildGridWidthClass(data));
		// Add Label
		itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));
		// Add TAG Label
		itemHtml = itemHtml.replace(/{{itemTagLabels}}/g, buildTagLabels(data, false));
        // Add Quick Buy
        itemHtml = itemHtml.replace(/{{itemVariants}}/g, buildVariants(data, Utils.variantFields));
		// Add Images
		itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
		// Add Price
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));

		// Add Review
		if (boostPFSThemeConfig.custom.show_product_review) {
			var itemReviewHtml = '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>';
			itemHtml = itemHtml.replace(/{{itemReviewHtml}}/g, itemReviewHtml);
		} else {
			itemHtml = itemHtml.replace(/{{itemReviewHtml}}/g, '');
		}

        // Add Title
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, buildTitle(data));
		// Add Vendor
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));
		// itemActiveSwapClass
		var itemActiveSwapClass = boostPFSThemeConfig.custom.active_image_swap ? 'has-bc-swap-image' : '';
		itemHtml = itemHtml.replace(/{{itemActiveSwapClass}}/g, itemActiveSwapClass);
		// Add Color Swatches
		itemHtml = itemHtml.replace(/{{itemColorSwatches}}/g, buildColorSwatches(data));

		// Add main attribute (Always put at the end of this function)
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
		itemHtml = itemHtml.replace(/{{itemButton}}/g, buildProductButton(data, Utils.variantFields));
		return itemHtml;
	};

	// Add variant fields in Utils for global use
	Utils.variantFields = JSON.parse(document.querySelector('.variant-scripts').innerHTML);

	// Build the product button
	function buildProductButton(product, fields) {
		var buyLocaly = false;
		var productId = product.id;
		var productVariants = product['variants'].length;
		var productLabels = Shopify.theme.locale.products.product
		var button = "<a href="+ Utils.buildProductItemUrl(product) +" class=\"btn btn--product\">"+ productLabels.shop_now +"</a>";

      fields.forEach(function(item) {
			if (item.id == productId && item.buy_localy == 'true' ) {
				buyLocaly = true;
			}
          
		})

		if (buyLocaly || !product.available) {
			var skus = product.skus.join(',')
			button =  "<a href=\"#store-locator-popup\" data-destini-container=\"destinidiv\" data-destini-association=\"default\" data-destini-apo=\""+ skus +",\" class=\"js-popup-trigger js-buy-locally btn btn--product\">"+ productLabels.buy_localy +"</a>"
		} else if (!buyLocaly && productVariants === 1 && product.available) {
			var form = "<form method=\"post\" action=\"/cart/add\" id=\"product_form_" + product.id + "\" accept-charset=\"UTF-8\" class=\"shopify-product-form\" enctype=\"multipart/form-data\"><div class=\"bold-bundles-product bold_bundles_product_loaded\"></div><input type=\"hidden\" name=\"form_type\" value=\"product\"><input type=\"hidden\" name=\"utf8\" value=\"✓\"><div class=\"form__row hidden\"><div class=\"form__controls\"><div class=\"select\"><select name=\"id\" id=\"product-select\" class=\"js-product-main-select js-variants-select\"><option data-sku=\"" + product['variants'][0].sku + "\" value=\"" + product['variants'][0].id + "\"></option></select></div></div></div>"
			if (cartType === 'drawer') {
				buttonAddToCart = "<button type=\"submit\" name=\"add\" class=\"btn btn--product js-ajax-add\">"+ productLabels.add_to_cart +"</button></form>";
				button = form.concat(' ', buttonAddToCart);
			} else if (cartType === 'page') {
				buttonAddToCart = "<button type=\"submit\" name=\"add\" class=\"btn btn--product\">"+ productLabels.add_to_cart +"</button></form>";
				button = form.concat(' ', buttonAddToCart);
			}
		}

		return button
	}

	// Build Product List Item
	ProductListItem.prototype.compileTemplate = function(data) {
		if (!data) data = this.data;
		// For List View
		/*** Prepare data ***/
		var images = data.images_info;
		// Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		/*** End Prepare data ***/
		// Get Template
		var itemHtml = boostPFSTemplate.productListItemHtml;
		// Customize API data to get the Shopify data
		data = prepareShopifyData(data);
		// Add Custom class
		var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
		var saleClass = onSale ? boostPFSTemplate.saleClass : '';
		itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
		itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
		// Add Label
		itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));
		// Add TAG Label
		itemHtml = itemHtml.replace(/{{itemTagLabels}}/g, buildTagLabels(data, false));
        // Add Quick Buy
        itemHtml = itemHtml.replace(/{{itemVariants}}/g, buildVariants(data, Utils.variantFields));
		// Add Images
		itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));

		// Add Review
		if (boostPFSThemeConfig.custom.show_product_review) {
			var itemReviewHtml = '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>';
			itemHtml = itemHtml.replace(/{{itemReviewHtml}}/g, itemReviewHtml);
		} else {
			itemHtml = itemHtml.replace(/{{itemReviewHtml}}/g, '');
		}

        // Add Title
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, buildTitle(data));
		// Add Vendor
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));
		// Add Price
		var itemPriceHtml = buildPrice(data, onSale, priceVaries);
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
    
		// Description
		var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
		itemDescription =
			itemDescription.split(' ').length > 35
				? itemDescription
						.split(' ')
						.splice(0, 35)
						.join(' ') + '...'
				: itemDescription
						.split(' ')
						.splice(0, 35)
						.join(' ');
		itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);
		// itemActiveSwapClass
		var itemActiveSwapClass = boostPFSThemeConfig.custom.active_image_swap ? 'has-bc-swap-image' : '';
		itemHtml = itemHtml.replace(/{{itemActiveSwapClass}}/g, itemActiveSwapClass);
		// Add Color Swatches
		itemHtml = itemHtml.replace(/{{itemColorSwatches}}/g, buildColorSwatches(data));

		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		return itemHtml;
		// End For List View
	};

	/************************** END BUILD PRODUCT LIST **************************/
	/************************** BUILD PRODUCT ITEM ELEMENTS **************************/
	function buildGridWidthClass() {
		var gridWidthClass = '';
		// On PC
		switch (boostPFSThemeConfig.custom.products_per_row) {
			case 2:
				gridWidthClass = 'boost-pfs-filter-grid-width-2';
				break;
			case 3:
				gridWidthClass = 'boost-pfs-filter-grid-width-3';
				break;
			case 5:
				gridWidthClass = 'boost-pfs-filter-grid-width-5';
				break;
			default:
				gridWidthClass = 'boost-pfs-filter-grid-width-4';
				break;
		}
		// On Mobile
		switch (boostPFSThemeConfig.custom.products_per_row_mobile) {
			case 1:
				gridWidthClass += ' boost-pfs-filter-grid-width-mb-1';
				break;
			case 3:
				gridWidthClass += ' boost-pfs-filter-grid-width-mb-3';
				break;
			default:
				gridWidthClass += ' boost-pfs-filter-grid-width-mb-2';
				break;
		}
		return gridWidthClass;
	}

	function buildImages(data) {
		var html = '';
		var aspect_ratio = '';
		// Build Main Image
		var thumbUrl = Utils.getFeaturedImage(images, '360x');

		var flipImageSrc =
			images.length > 1
				? Utils.optimizeImage(images[1]['src'], '360x')
				: images.length > 0
				? Utils.optimizeImage(images[0]['src'], '360x')
				: boostPFSAppConfig.general.no_image_url;
		var flipImageSrcset = boostPFSAppConfig.general.no_image_url;
		if (images.length > 0) {
			var flipImageSrcset =
				images.length > 1
					? Utils.optimizeImage(images[1]['src'], '180x') +
					  ' ' +
					  '180w' +
					  ', ' +
					  Utils.optimizeImage(images[1]['src'], '260x') +
					  ' ' +
					  '260w' +
					  ', ' +
					  Utils.optimizeImage(images[1]['src'], '360x') +
					  ' ' +
					  '360w' +
					  ', ' +
					  Utils.optimizeImage(images[1]['src'], '480x') +
					  ' ' +
					  '480w'
					: Utils.optimizeImage(images[0]['src'], '180x') +
					  ' ' +
					  '180w' +
					  ', ' +
					  Utils.optimizeImage(images[0]['src'], '260x') +
					  ' ' +
					  '260w' +
					  ', ' +
					  Utils.optimizeImage(images[0]['src'], '360x') +
					  ' ' +
					  '360w' +
					  ', ' +
					  Utils.optimizeImage(images[0]['src'], '480x') +
					  ' ' +
					  '480w';
		}

		html += '<a href="{{itemUrl}}" class="boost-pfs-filter-product-item-image-link" style="padding-top:';

		if (images.length > 0) {
			aspect_ratio = images[0]['width'] / images[0]['height'];
			html += (1 / aspect_ratio) * 100;
		} else {
			html += 100;
		}
		html += '%;">';
		html +=
			'<img class="boost-pfs-filter-product-item-main-image lazyload Image--lazyLoad"' +
			'data-srcset="' +
			Utils.getFeaturedImage(images, '180x') +
			' ' +
			'180w' +
			', ' +
			Utils.getFeaturedImage(images, '260x') +
			' ' +
			'260w' +
			', ' +
			Utils.getFeaturedImage(images, '360x') +
			' ' +
			'360w' +
			', ' +
			Utils.getFeaturedImage(images, '480x') +
			' ' +
			'480w' +
			'" ' +
			'data-src="' +
			thumbUrl +
			', ' +
			Utils.getFeaturedImage(images, '480x') +
			' ' +
			'480w' +
			'" ' +
			'data-widths="[180, 260, 360, 480]" ' +
			'data-sizes="auto" ' +
			'src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" ' +
			'data-img-flip = "' +
			flipImageSrc +
			'" ' +
			'data-img-flip-srcset = "' +
			flipImageSrcset +
			'" ' +
			'alt="' +
			data.title +
			'" />';
        html += '<div class="boost-pfs-filter-product-item-main-image-overlay"><span>View Details</span></div>';
		html += '</a>';

		return html;
	}

    function buildVariants(data, fields) {
      var html = '';
      var buyLocaly = false;
      var onlineOnly = false;
      var onHold = false;
      var bundle = false;
      var showMore = '';
      var getFirstAvail = function(){
        // Get First Variant (selected_or_first_available_variant)
        if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
          var paramVariant = data.variants.filter(function(e) {
            return e.id == Utils.getParam('variant');
          });
          if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
        } else {
              for (var i = 0; i < data['variants'].length; i++) {
                if (data['variants'][i].available) {
                  firstVariant = data['variants'][i];
                  break;
                }
              }
        }
       };
       
      fields.forEach(function(item) {
		if (item.id == data.id && item.buy_localy == 'true' ) {
			buyLocaly = true;
		}
	  })

      if (data.tags) {
            for (var i = 0; i < data.tags.length; i++) {
        		var tag = data.tags[i];
                if (tag.indexOf('more-sizes') !== -1) {
                    showMore = '<a class="collection-item-more-sizes" href="{{itemUrl}}"><span>More sizes</span></a>';
				}
        		if (tag.indexOf('option_online-only') !== -1) {
        			onlineOnly = true;
                    break;
            	}
                if (tag.indexOf('option_on-hold') !== -1) {
        			onHold = true;
                    break;
            	}
                if (tag.indexOf('collection_Rice + Friends') !== -1 ||
  					tag.indexOf('collection_Bundles') !== -1) {
        			bundle = true;
                    break;
            	}
            }
      }

      if (bundle === true) {
        html += '<div class="collection-quick-add variants">';
        html += '<form action="/cart/add" method="post" >';
        html += '<select name="id" class="quick-add-select" style="display:none">';
                    for (var l = 0; l < data.variants.length; l++) {
                        var firstVariant;
              		  var variant = data['variants'][l];
                        var avail;
                        var firstAvail;
                          getFirstAvail();
                          if (!variant.available || onHold){ 
                            avail = ' disabled="disabled"';
                          } else {
                            avail = '';
                          }
                          if (variant == firstVariant){ 
                            firstAvail = ' checked="checked"';
                          } else {
                            firstAvail = '';
                          }
                        html += '<option value="' + variant.id + '"'+ avail + firstAvail +'>' + variant.title + '</option>';  
                    }
        html += '</select>';
                    html += showMore;
                    if (!data.available || onHold) {
                      html += '<button type="button" value="Sold Out" class="quick-add-button btn btn--product" disabled>Sold Out</button>';
                    } else {
                      html += '<button type="submit" value="Add to Cart" class="quick-add-button btn btn--product">Add to Cart</button>';
                    }
        html += '</form>';
        html += '</div>';
        return html;
        
      } else {

       if (onHold == true || data.available == false && onlineOnly == true ) {
        html += showMore;
        html += '<button type="button" value="Sold Out" disabled class="quick-add-button btn btn--product">Sold Out</button>';
        return html;
       }
       else if (buyLocaly && data.available == false ) {
			var skus = data.skus.join(',');
            html += showMore;
			html +=  '<a href="#store-locator-popup" data-destini-container="destinidiv" data-destini-association="default" data-destini-apo="'+ skus +'," class="quick-add-buy-locally js-popup-trigger js-buy-locally">Find where to buy</a>';
            html += '<button type="button" value="Sold Out" disabled class="quick-add-button btn btn--product">Sold Out</button>';
            return html;
       } else {
      
           for (var index = 0; index < data.options.length; index++) {
  			 var option = data['options'][index].toLowerCase();
                    html += '<div class="collection-quick-add variants">';
                    html += '<form action="/cart/add" method="post" >'
                    html += '<fieldset class="quick-add-options">'
                    html += '<ul>';
                    
                    for (var k = 0; k < data.variants.length; k++) {
              		var firstVariant;
              		var variant = data['variants'][k];
                      var vprice = Utils.formatMoney(variant.price);
                      var productID = data.id;
                      var variantTitle;
                      var avail;
                      var firstAvail;
                          if (variant.title == '24 x 1 oz. single-serve bags'){
                            variantTitle = '24 x 1 oz.';
                          } else {
                            variantTitle = variant.title;
                          }
                          getFirstAvail();
                          if (!variant.available){ 
                            avail = ' disabled="disabled"';
                          } else {
                            avail = '';
                          }
                          if (variant == firstVariant){ 
                            firstAvail = ' checked="checked"';
                          } else {
                            firstAvail = '';
                          }
                          html += '<li>';
                          html += '<input style="display:none" id="'+ productID +'-option'+ k +'" type="radio" name="'+ productID +'-option" value="'+ variant.id +'" data-price="'+ vprice +'"'+ avail + firstAvail +'/>';
                          html += '<label for="'+ productID +'-option'+ k +'">'+ variantTitle +'</label>';
                          html += '</li>';
                    }
                    
  				  html += '</ul>';
                    html += '</fieldset>';
                    html += '<select name="id" class="quick-add-select" style="display:none">';
                    for (var l = 0; l < data.variants.length; l++) {
                        var firstVariant;
              		  var variant = data['variants'][l];
                        var avail;
                        var firstAvail;
                          getFirstAvail();
                          if (!variant.available){ 
                            avail = ' disabled="disabled"';
                          } else {
                            avail = '';
                          }
                          if (variant == firstVariant){ 
                            firstAvail = ' checked="checked"';
                          } else {
                            firstAvail = '';
                          }
                        html += '<option value="' + variant.id + '"'+ avail + firstAvail +'>' + variant.title + '</option>';  
                    }
                    html += '</select>';
                    html += showMore;
                    if (!data.available) {
                      html += '<button type="button" value="Sold Out" class="quick-add-button btn btn--product" disabled>Sold Out</button>';
                    } else {
                      html += '<button type="submit" value="Add to Cart" class="quick-add-button btn btn--product">Add to Cart</button>';
                    }
                    html += '</form>';
                    html += '</div>';
              }
          return html;
       }
      }
    }

    function buildTitle(data) {
		var html = '';
		html += '<a href="{{itemUrl}}"<h3 class="boost-pfs-filter-product-item-title">' + data.title + '</h3></a>';
		return html;
	}

	function buildVendor(data) {
		var html = '';
		if (boostPFSThemeConfig.custom.show_vendor) {
			html = boostPFSTemplate.vendorHtml;
		}
		return html;
	}

	function buildPrice(data) {
		var html = '';
		if (boostPFSThemeConfig.custom.show_price) {
			html = '<p class="boost-pfs-filter-product-item-price">';
			if (onSale) {
				html += '<span class="boost-pfs-filter-product-item-sale-price">' + Utils.formatMoney(data.price_min) + '</span>';
				html += '<s>' + Utils.formatMoney(data.compare_at_price_min) + '</s> ';
			} else {
				if (priceVaries) {
					html += '<span class="boost-pfs-filter-product-item-price-from-text">' + boostPFSThemeConfig.label_basic.from + ' ' + '</span>';
				}
				html += '<span class="boost-pfs-filter-product-item-regular-price js-quick-add-price">' + Utils.formatMoney(data.price_min) + '</span>';
			}
			html += '</p>';
		}
		return html;
	}

	function buildLabels(data) {
		// Build Sold out label
		var soldOutLabel = '';
		if (boostPFSThemeConfig.custom.show_sold_out_label && soldOut) {
			soldOutLabel = boostPFSTemplate.soldOutLabelHtml.replace(/{{style}}/g, '');
		}
		// Build Sale label
		var saleLabel = '';
		if (boostPFSThemeConfig.custom.show_sale_label && onSale && !soldOut) {
			saleLabel = boostPFSTemplate.saleLabelHtml.replace(/{{style}}/g, '');
		}
		// Build Labels
		return soldOutLabel + saleLabel;
	}

	// BUILD LABEL PRODUCT WITH TAGS
	function buildTagLabels(data, showall) {
		if (boostPFSThemeConfig.custom.show_lable_by_tag) {
			if (showall) {
				var tagLabel = '';
				if (data.tags) {
					for (var i = 0; i < data.tags.length; i++) {
						var tag = data.tags[i];
						if (tag.indexOf('pfs:label') !== -1) {
                            if (tag.indexOf('ROC') !== -1) {
                                var svg = '<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" style="enable-background:new 0 0 612 241.05" version="1.1" viewBox="0 0 612 241.05"><style>.roc-color{fill:#9b6846}</style><path d="M152.4 164.88c1.84-1.62 3.7-3.4 5.71-5.01 2.42-1.95 4.89-3.85 7.45-5.61 4.56-3.14 9.1-6.32 13.83-9.18 5.02-3.04 10.8-.25 11.65 5.56 1.88 12.78 1.5 25.48-1.75 38.03-.21.82-.46 1.63-.69 2.44.12.08.23.15.35.23 1.78-1.79 3.61-3.53 5.34-5.37 1.14-1.22 2.15-2.56 3.21-3.86 9.94-12.23 16.47-26.08 19.68-41.49 3.32-15.95 2.77-31.76-1.7-47.44-2.57-9.01-6.31-17.48-11.36-25.39-3.93-6.16-8.29-11.96-13.69-16.89-3.26-2.98-6.7-5.74-10.05-8.62-4.32-3.73-9.46-6.08-14.43-8.76-7.12-3.85-14.79-5.96-22.65-7.42-1.85-.34-3.87-.17-5.75.11-2.2.33-3.14 1.51-3.31 3.77-.14 1.98-.11 3.97-.11 5.95.02 9.27.06 18.54.1 27.8v1.48c.63-.56 1.03-.87 1.38-1.24 3.77-3.85 7.43-7.83 11.36-11.51 1.36-1.27 3.34-2.39 5.14-2.57 3.28-.33 7.37 2.61 7.84 6.67.32 2.75-.41 5.09-2.4 7.09-3.63 3.64-7.19 7.33-10.76 11.02-4.69 4.86-9.41 9.7-14.02 14.63-1.59 1.7-3.61 2.88-5.68 2.92-1.78.04-4-.89-5.32-2.13-4.85-4.56-9.41-9.43-14.07-14.2-1.31-1.34-2.54-2.76-3.84-4.11-2.78-2.9-5.6-5.75-8.36-8.66-3.74-3.95-2.16-10.38 2.8-12.61 3.47-1.55 6.04-.25 8.33 1.94 3.74 3.59 7.27 7.39 10.9 11.1.37.38.78.73 1.44 1.34V62.2c-.02-10.79-.26-21.59 0-32.38.28-11.67 8.27-19.33 19.96-19.82 6.86-.29 13.34 1.57 19.76 3.56 7.9 2.45 15.37 5.95 22.44 10.21 4.17 2.51 8.17 5.36 11.96 8.41 6.26 5.05 12.04 10.69 16.88 17.11 3.99 5.3 7.78 10.85 10.94 16.68 8.1 14.92 12.51 30.96 13.43 47.94.68 12.51-.6 24.79-3.9 36.88-2.42 8.88-5.85 17.32-10.36 25.35-3.45 6.14-7.29 11.99-11.96 17.27-2.49 2.81-4.97 5.66-7.69 8.24-3.2 3.03-6.5 6.01-10.05 8.61-4.25 3.12-8.78 5.84-13.22 8.68-6.45 4.13-13.66 6.44-20.89 8.73-18.75 5.94-37.64 5.84-56.51 1.03-7.61-1.94-15.09-4.63-22.01-8.48-4.61-2.57-9.13-5.35-13.43-8.39-3.64-2.57-7.08-5.48-10.34-8.53-5.41-5.09-10.35-10.65-14.62-16.74-9.5-13.55-15.92-28.44-18.93-44.74-3.03-16.35-2.62-32.61 1.35-48.77 2.16-8.78 5.29-17.18 9.47-25.22 3.1-5.98 6.67-11.62 10.76-16.98 4.81-6.29 10.07-12.13 16.3-17.03 3.86-3.04 7.92-5.84 11.87-8.77 4.87-3.61 10.4-5.92 15.91-8.3 1.2-.52 2.33-1.21 3.56-1.63 4.39-1.5 7.94.6 9.7 4.75 1.67 3.94-.28 8.38-4.2 10.04-.89.38-1.86.6-2.7 1.05-6.03 3.25-12.19 6.29-17.99 9.92-3.76 2.35-7.14 5.39-10.39 8.45-5.3 5-9.99 10.57-13.99 16.66-6.82 10.39-11.63 21.67-14.2 33.85-2.98 14.15-2.94 28.29.25 42.41 2.02 8.94 5.19 17.42 9.64 25.45 3.42 6.17 7.34 11.96 12.12 17.15 1.47 1.6 2.94 3.22 4.42 4.81.22.24.52.4.82.63-.84-3.81-1.82-7.49-2.46-11.23-1.6-9.44-1.88-18.95-.54-28.44.81-5.75 6.43-8.47 11.51-5.64 3.38 1.88 6.74 3.84 9.94 6 3.96 2.67 7.8 5.51 11.59 8.42 2.73 2.09 5.28 4.42 8.22 6.91-.11-1.41-.17-2.43-.26-3.45-1.14-12.91.52-25.41 5.68-37.34 2.35-5.43 5.3-10.55 9.28-15 1.62-1.81 3.19-3.69 4.99-5.31 3.56-3.21 7.52-3.17 11.12.04 5.23 4.66 9.17 10.31 12.37 16.5 5.26 10.19 7.69 21.07 7.81 32.5.05 3.5.02 7 .02 10.63zm-14.94-9.18c-.49-4.19-.78-8.41-1.51-12.55-1.22-6.88-3.92-13.23-7.78-19.07-1.08-1.63-2.13-1.66-3.1.07-1.87 3.31-3.85 6.62-5.22 10.14-3.65 9.33-4.45 19.08-3.35 28.98 1.14 10.26 4.12 20 8.61 29.28.27.56 1.02 1.31 1.47 1.26.58-.07 1.3-.74 1.58-1.33 1.21-2.63 2.35-5.29 3.39-7.99 3.57-9.27 5.55-18.83 5.91-28.79zm-21.23 59.97c.76.03 1.33-.81.88-2.32-1.49-5.02-3.98-9.56-6.8-13.93-3.41-5.26-7.48-10.02-11.84-14.49-3.26-3.34-6.78-6.43-10.32-9.48-2.47-2.12-5.17-3.97-7.76-5.95-1.12-.86-2.17-1.82-3.34-2.6-1.11-.73-2.17-.14-2.21 1.19-.03.91-.01 1.85.17 2.74.94 4.83 1.6 9.75 2.96 14.46 2.63 9.06 7.49 16.76 15.37 22.27 2.07 1.45 4.22 2.83 6.48 3.94 4.94 2.44 10.25 3.64 16.41 4.17zm60.62-45.64c0-.46.08-.94-.02-1.37-.16-.65-.3-1.62-.72-1.8-.54-.22-1.45.05-2.02.4-.93.58-1.71 1.4-2.56 2.11-3.39 2.83-6.89 5.54-10.14 8.52-3.37 3.08-6.52 6.4-9.71 9.67-4.04 4.13-7.45 8.79-10.27 13.8-2.13 3.78-3.67 7.91-5.34 11.93-.67 1.61.14 2.52 1.81 2.3 5.91-.77 11.6-2.04 16.95-5.02 6.24-3.48 11.25-8.05 14.81-14.14 4.75-8.13 6.65-17.08 7.21-26.4z" class="roc-color"/><path d="M177.57 132.1c-5.06.04-9.91-.88-14.3-3.36-8.01-4.53-12.43-11.57-13.34-20.65-.9-9.02 1.12-17.12 8.05-23.63 3.32-3.12 7.17-4.96 11.46-6 6.81-1.64 13.55-1.3 20.13 1.23 5.73 2.19 10.05 6.13 12.73 11.5 4.12 8.27 4.39 16.91.58 25.38-4.87 10.81-13.85 15.27-25.31 15.53zm-10.15-27.5c.32 1.48.56 2.99.97 4.44 1.97 7.04 10.75 9.36 15.83 4.1 3.24-3.36 3.74-7.51 2.79-11.93-1.29-6.05-7.4-9.33-13.18-7.07-3.99 1.55-6.26 5.35-6.41 10.46zM86.76 109.94c2.91 4.77 5.78 9.44 8.63 14.13.71 1.17 1.4 2.35 2.04 3.56.8 1.5.01 3.03-1.68 3.05-4.84.07-9.69.09-14.52-.05-.73-.02-1.71-.89-2.11-1.62-2.7-5.01-5.27-10.08-7.89-15.13-.27-.53-.59-1.03-.88-1.54l-.39.06c-.03.51-.09 1.01-.09 1.52-.01 4.63 0 9.26-.01 13.9 0 2.31-.58 2.89-2.88 2.9-3.57.01-7.14.01-10.7 0-2.07-.01-2.69-.59-2.69-2.6-.01-15.63-.01-31.25 0-46.88 0-1.73.52-2.36 2.07-2.35 7.69.04 15.39.02 23.08.24 2.2.06 4.45.64 6.55 1.36 6.21 2.11 9.4 6.69 9.99 13.09.6 6.49-1.35 11.85-7.29 15.28-.45.25-.81.7-1.23 1.08zM69.81 92.48v8.37c2.33-.29 4.57-.36 6.69-.9 1.84-.46 2.58-2.11 2.37-4.11-.17-1.61-1.15-2.8-2.93-3.03-1.99-.26-4.02-.23-6.13-.33zM318.17 80.86c2.97 0 5.41-.04 7.85.04.47.02.97.45 1.38.78 2.07 1.62 4.23 3.08 7.01 2.75 4.3-.5 8.79-4.1 8.65-9.71-.65.74-1.14 1.49-1.81 2.02-4.33 3.45-9.1 3.57-13.95 1.42-6.54-2.89-10.73-11.03-8.98-19.19 1.45-6.73 7.8-12.8 15.04-12.55 3.59.12 6.85 1.03 8.93 4.33.07.11.23.15.57.37v-3.7c2.17 0 4.15-.05 6.12.06.31.02.82.78.83 1.2.07 3.77.06 7.53.03 11.3-.04 5.34.18 10.71-.26 16.02-.57 6.9-4.11 12.16-10.73 14.13-6.71 1.99-12.74.79-17.62-4.44-1.18-1.25-1.89-2.94-3.06-4.83zm6.88-17.55c.21.96.42 2.38.85 3.72 1.16 3.66 5.78 6.27 9.54 5.48 4.08-.86 6.78-4.02 7.14-8.61.28-3.56-.8-6.67-3.71-8.89-2.71-2.06-5.72-2.28-8.78-.79-3.6 1.75-4.79 4.92-5.04 9.09zM315.87 143.63c2.67 0 5.11-.05 7.54.04.51.02 1.05.52 1.48.91 3.71 3.32 9.5 3.3 12.87-.23 1.71-1.79 2.64-4.04 2.77-7.03-1.92 2.36-4.03 3.76-6.62 4.39-5.78 1.41-13.62-1.35-17-8.84-3.84-8.5-.65-20.38 10.44-23.29 4.93-1.29 8.69.16 12.1 3.45.17.16.19.46.29.7.15-.1.3-.19.44-.29.05-.98.1-1.96.15-3.05h6.78c.04.33.11.63.11.92-.01 8.6.12 17.21-.08 25.8-.14 6-2.37 10.99-7.83 14.32-5.12 3.13-10.38 3.27-15.55.82-3.52-1.66-6.44-4.39-7.89-8.62zm6.64-18.26v.61c-.03 5.7 5.72 10.36 10.13 9.38 3.73-.83 7.26-4.39 7.46-9.58.16-4.08-3.43-9.03-7.04-9.79-5.74-1.2-10.63 3.96-10.55 9.38zM275.34 98.88c7.4.2 13.23 3.62 17.18 9.67 5.37 8.23 4.21 18.27-.95 25.34-6.32 8.67-21.57 11.78-31.23 1.86-6.67-6.86-7.85-16.52-3.84-24.91 2.07-4.33 5.38-7.24 9.47-9.59 2.94-1.71 6.05-2.19 9.37-2.37zm13.29 20.29c.07-3.81-2.23-7.76-6.04-10.69-5.15-3.96-13.02-2.53-16.56 1.49-3.3 3.75-4.71 7.79-4.24 12.69.75 7.71 9.66 14.59 17.55 11.44 5.53-2.21 9.51-7.61 9.29-14.93zM256.06 37.3c5.08 0 10.03-.15 14.95.03 8.5.32 13.09 8.99 11.17 16.08-1.29 4.79-3.86 8.37-8.99 9.55-.29.07-.56.21-.97.36 3.53 5 7.01 9.92 10.67 15.11-.75.04-1.27.09-1.78.09-1.48.01-2.98-.15-4.43.04-2.13.28-3.33-.63-4.38-2.39-1.58-2.66-3.42-5.17-5.12-7.75-1.17-1.77-2.3-3.57-3.77-5.29v15.25h-7.36c.01-13.65.01-27.31.01-41.08zm7.35 7.02v12.32c2.37 0 4.67.27 6.89-.06 3.14-.48 4.89-2.81 4.92-5.87.03-3.04-1.75-5.5-4.78-6.01-2.26-.39-4.62-.27-7.03-.38zM466.7 175.2v-12.52h7.06v41.16h-6.36c-.06-1.07-.13-2.19-.19-3.31-1.45 1.13-2.67 2.54-4.21 3.2-4.78 2.03-9.34 1.51-13.63-1.64-6.46-4.74-8.11-11.13-6.36-18.51 2.01-8.44 10.4-13.43 18.49-11.28.92.24 1.82.65 2.66 1.11.79.44 1.49 1.04 2.54 1.79zm.53 13.08c-.03-5.37-3.9-9.59-8.81-9.61-4.86-.02-8.95 4.33-8.85 9.58.1 5.2 3.56 9.73 8.82 9.78 5.29.04 8.73-4.74 8.84-9.75zM293.53 174.21c-2.54 0-5.09.07-7.62-.05-.58-.03-1.19-.68-1.67-1.16-6.58-6.42-16.56-5.05-20.79 3.06-2.98 5.71-2.28 12.6 2.66 17.45 4.53 4.45 10.32 5.36 15.23 2.2 1.08-.7 1.87-1.84 2.91-2.63.59-.45 1.39-.82 2.11-.86 2.33-.11 4.67-.04 7.14-.04-.84 2.9-2.53 5.08-4.64 6.95-6.05 5.38-13.02 7.33-20.63 4.31-10.13-4.01-15.81-14.27-13.33-25.22 2.15-9.5 9.85-16.38 19.9-16.47 5.69-.05 10.77 1.84 14.75 5.97 1.69 1.76 2.89 3.98 4.31 5.99-.12.18-.23.34-.33.5zM439.54 191.59h-23.09c.61 3.23 3.15 5.65 6.44 6.3 3.33.66 6.5-.56 8.21-3.12.2-.31.51-.76.78-.77 2.32-.06 4.65-.04 7.16-.04-.78 2.69-2.25 4.63-4.02 6.43-6.23 6.32-14.02 5.22-18.19 2.54-7.12-4.56-9.67-11.53-7.32-19.72 1.66-5.78 5.43-9.85 11.64-11.05 5.15-1 9.99-.11 13.75 3.65 4.26 4.27 5.94 9.55 4.64 15.78zm-7.01-6.18c-.81-4.44-3.98-6.92-8.38-6.73-4.15.18-7.53 3.06-7.84 6.73h16.22zM492.82 51.02v-3.59c2.09 0 4.02-.05 5.94.06.25.01.66.78.67 1.21.06 3.21.03 6.41.03 9.62V78.42h-6.63v-3.51c-2.91 2.91-6.2 4.4-10.03 4.58-3.44.16-6.64-.76-9.22-3.05-3.75-3.33-5.59-7.63-5.79-12.67-.22-5.57 1.72-10.2 5.68-14.1 4.22-4.16 13.67-4.24 17.74-.07.47.48.86 1.02 1.29 1.54.1-.03.21-.08.32-.12zm-.18 11.74c-.2-2.53-.7-5.03-2.69-6.99-4.44-4.38-11.85-2.78-14.04 3.05-1.78 4.74-.85 9.38 2.51 11.94 2.83 2.16 5.97 2.56 9.2 1.03 3.74-1.77 4.83-5.11 5.02-9.03z" class="roc-color"/><path d="M325.87 191.54h-22.86c.12 3.04 3.3 6.02 6.81 6.4 3.27.35 6.05-.51 7.93-3.45.17-.27.6-.52.92-.53 2.18-.05 4.37-.02 6.63-.02.02.29.09.5.03.66-3.48 8.46-12.82 13.58-21.9 8.37-10.15-5.83-9.79-17.92-4.96-24.97 4.73-6.9 16.72-8.53 23.27-1.9 3.78 3.79 5.72 10.77 4.13 15.44zm-6.94-6.13c-.37-4.04-3.71-6.8-8.04-6.74-4.27.06-7.87 3.04-8.09 6.74h16.13zM425.99 66.19c.05.45 0 .78.12 1.04 1.22 2.89 3.38 4.68 6.46 5.25 2.95.54 5.65-.05 7.59-2.47.78-.97 1.53-1.28 2.69-1.23 1.82.08 3.65.02 5.62.02-.12.48-.16.82-.29 1.12-4.63 10.3-16.09 12.35-23.67 6.35-5.53-4.38-7.3-10.5-5.67-17.41 2.41-10.2 12.45-15.36 22.04-10.9 6.06 2.82 9.65 10.1 8.46 17.29-.17 1.04-.88.92-1.59.92h-20.04c-.54.02-1.09.02-1.72.02zm16.04-5.83c-.28-4.26-3.38-6.94-7.79-7.06-3.67-.1-7.98 2.29-8.33 7.06h16.12zM568.82 66.19c.4 3.39 3.95 6.31 7.7 6.46 2.81.11 5.21-.75 6.92-3.13.21-.3.6-.66.92-.67 2.28-.06 4.55-.03 7.02-.03-.22.61-.33 1.04-.52 1.43-4.84 10.15-16.11 11.86-23.43 6.11-5.53-4.34-7.39-10.4-5.8-17.35 2.31-10.06 11.91-15.17 21.37-11.37 6.34 2.55 10.5 10.37 9.1 17.75-.05.24-.16.47-.27.8h-23.01zm16.07-5.8c-.54-4.75-3.8-7.33-8.72-7.04-4.07.24-7.45 3.44-7.38 7.04h16.1zM313.53 68.81c-4.05 11.17-16.5 13.88-24.37 7.2-8.52-7.23-6.8-19.09-.94-25.19 4.6-4.79 13.89-5.8 19.24-2 5.43 3.86 8.39 10.74 6.54 17.36h-23.09c.18.67.23 1.22.46 1.66 3.31 6.37 11.53 5.96 14.25 1.7.21-.33.69-.69 1.05-.7 2.22-.06 4.45-.03 6.86-.03zm-6.47-8.43c-.51-4.76-3.91-7.39-8.88-7.02-3.96.29-7.34 3.58-7.2 7.02h16.08zM361.2 66.19c.03.49-.02.76.07.98 1.24 2.95 3.43 4.78 6.57 5.33 3.01.53 5.71-.16 7.67-2.65.6-.77 1.18-1.1 2.15-1.06 1.93.08 3.87.02 5.94.02-.08.44-.08.79-.21 1.08-4.72 10.53-16.39 12.36-23.89 6.24-5.36-4.37-7.07-10.44-5.48-17.21 2.31-9.85 11.72-15.17 21.45-11.25 6.29 2.54 10.41 10.47 9.05 17.67-.19 1.01-.84.84-1.47.84-6.27.01-12.54 0-18.81 0-.95.01-1.91.01-3.04.01zm-.15-5.86h16.2c-.4-4.19-3.32-6.89-7.49-7-4.74-.13-8.07 2.52-8.71 7zM375.73 113.94v-3.52h6.51v30.59h-6.41c-.06-1.03-.12-2.06-.17-3.09-1.51.94-2.85 1.95-4.33 2.68-6.47 3.16-14.46.98-17.96-5.09-3.02-5.25-3.55-10.84-1.45-16.62 1.69-4.65 5.03-7.41 9.62-9.08 5.32-1.94 9.46.05 13.36 3.34.18.16.35.33.83.79zm-.2 11.73c.27-4.2-2.73-8.25-5.66-9.28-6.35-2.24-11.31 2.35-11.93 8.45-.6 5.87 3.24 9.43 7.18 10.44 5.27 1.37 10.68-3.8 10.41-9.61zM395.45 78.45h-7.14V47.57h6.43c.07.66.14 1.34.19 1.86 1.79-.89 3.5-2.13 5.39-2.6 6.45-1.58 12.75 2 14.13 9.46.15.8.28 1.62.28 2.42.02 6.51.01 13.02.01 19.68h-6.99c-.03-.55-.07-1.13-.08-1.72-.04-5.29-.03-10.59-.14-15.88-.03-1.25-.29-2.54-.7-3.73-.91-2.66-2.92-3.91-5.63-3.73-2.6.18-4.91 2.14-5.35 4.69-.25 1.45-.37 2.93-.39 4.4-.05 4.73-.02 9.47-.02 14.21.01.56.01 1.11.01 1.82zM414.71 141.07h-7.43c-.03-.57-.07-1.11-.07-1.64-.01-4.94.01-9.88-.01-14.81-.01-2.27-.6-4.35-1.61-6.43-1.37-2.84-6.6-3.16-8.74-.28-1.38 1.86-1.83 3.95-1.86 6.17-.06 4.99-.04 9.98-.06 14.97V141h-6.98v-30.57h6.38c.06.66.13 1.31.17 1.81 1.93-.94 3.79-2.04 5.79-2.73 1.27-.44 2.76-.39 4.14-.31.81.04 1.6.56 2.4.87 3.9 1.54 6.69 4.25 6.99 8.49.53 7.43.62 14.89.89 22.51zM460.81 120.48c-2.52 0-5.02.14-7.47-.09-.66-.06-1.24-1.2-1.81-1.89-2.89-3.51-8.19-3.54-11.33-.21-3.21 3.41-3.64 7.25-2.13 11.45.98 2.72 3.14 4.49 5.72 5.32 3.56 1.15 5.38.36 8.35-3.01.65-.74 1.23-1.04 2.18-1.02 2.13.06 4.27.02 6.57.02-1.08 3.49-2.91 6.25-5.8 8.27-6.89 4.81-17.21 3.1-21.93-3.85-6.55-9.64-2.27-22.75 9.3-25.94 6.68-1.84 16.69 3.2 18.32 10.32.03.14.01.29.03.63zM532.61 47.42c2.56 0 4.84-.06 7.11.06.39.02.92.7 1.09 1.18 2.21 6.23 4.36 12.48 6.53 18.72.06.18.19.34.41.73 1.13-3.39 2.21-6.58 3.26-9.77 1.1-3.33 2.17-6.67 3.31-9.98.13-.38.63-.88.98-.89 2.28-.08 4.57-.04 7.07-.04-.42 1.25-.74 2.35-1.15 3.41-3.03 7.71-6.09 15.41-9.14 23.12-.37.94-.81 1.88-1.03 2.86-.33 1.52-1.25 1.78-2.65 1.75-3.8-.08-3.72-.06-5.09-3.68-1.81-4.81-3.78-9.55-5.65-14.33-1.66-4.26-3.28-8.54-5.05-13.14zM378.76 172.85c.48 0 .99.13 1.38-.03.41-.17.89-.55 1.01-.94.32-1.06.42-2.19.68-3.27 1.12-4.56 6.27-7.72 10.93-6.65v7.17c-2.44-.11-4.42.47-4.39 3.64h4.01v6.7h-4.12v24.43h-7.07v-24.04c-.29-.19-.37-.28-.46-.29-2.21-.23-2.22-.23-2.21-2.57 0-1.22.02-2.44.04-3.66.01-.11.08-.2.2-.49zM351.13 179.47h-3.45v-6.54c1.05-.05 2.1-.1 3.35-.16v-10.11h7.15v10.13h4.27v6.62h-4.18v24.42h-7.14v-24.36zM514.94 47.41h4.2v6.7c-.84 0-1.69.07-2.52-.02-1.25-.13-1.67.3-1.65 1.6.06 6.92.03 13.84.03 20.77v1.95h-7.08V54.23c-1.25-.07-2.33-.14-3.6-.22 0-1.99-.03-3.91.04-5.83.01-.26.54-.68.86-.72.79-.11 1.61-.03 2.58-.03V37.32h7.15c-.01 3.29-.01 6.57-.01 10.09zM336.95 172.95c.05.73.09 1.37.17 2.5 1.71-2.7 3.92-3.79 6.85-3.61v7.08c-.26.06-.58.16-.92.23-3.83.79-5.43 2.7-5.47 6.71-.05 5.4-.01 10.79-.01 16.19v1.84h-7.11v-30.93c2.2-.01 4.31-.01 6.49-.01zM460.01 47.42c.05.91.08 1.61.14 2.81 1.72-2.77 3.9-3.99 6.93-3.76v7.07c-.13.05-.26.13-.4.16-4.24.7-5.92 2.59-5.96 6.88-.05 5.34-.01 10.68-.01 16.02v1.8h-7.22v-1.64c0-9.2.03-18.41-.03-27.61-.01-1.45.44-1.85 1.81-1.75 1.51.1 3.04.02 4.74.02zM307.34 141.03h-7.09V110.4h6.38c.07.67.13 1.35.23 2.27 1.88-2.17 3.85-3.83 6.89-3.65v7.06c-.2.06-.43.19-.67.2-3.74.13-5.7 3.66-5.7 6.39-.01 5.5-.02 10.99-.04 16.49v1.87zM405.11 203.88h-7.02v-30.95h7.02v30.95zM366.69 203.87v-30.92h6.96v30.92h-6.96zM530.64 78.45h-7.1V47.43c2.14 0 4.27-.03 6.39.04.25.01.65.58.68.92.09 1.16.04 2.34.04 3.5v24.4c-.01.66-.01 1.32-.01 2.16zM426.16 141.05h-6.96v-30.67h6.96v30.67zM405.12 169.38h-7.01v-6.68h7.01v6.68zM366.67 169.33v-6.66h6.97v6.66h-6.97zM419.22 99.71c2.07 0 4.14-.03 6.21.04.28.01.77.51.78.8.07 1.92.04 3.85.04 5.89h-7.03v-6.73zM523.52 43.94v-6.6h7.01v6.6h-7.01zM491.45 166.1c0 3.16-2.48 5.64-5.71 5.64-3.2 0-5.75-2.48-5.75-5.64 0-3.09 2.55-5.58 5.75-5.58 3.23.01 5.71 2.49 5.71 5.58zm-10.03 0c0 2.48 1.84 4.45 4.35 4.45 2.45 0 4.25-1.97 4.25-4.42 0-2.48-1.8-4.49-4.28-4.49-2.49.01-4.32 2.02-4.32 4.46zm3.43 2.93h-1.29v-5.58c.51-.1 1.22-.17 2.14-.17 1.05 0 1.53.17 1.94.41.31.24.54.68.54 1.22 0 .61-.48 1.09-1.16 1.29v.07c.54.2.85.61 1.02 1.36.17.85.27 1.19.41 1.39h-1.39c-.17-.2-.27-.71-.44-1.36-.1-.61-.44-.88-1.16-.88h-.61v2.25zm.04-3.16h.61c.71 0 1.29-.24 1.29-.82 0-.51-.37-.85-1.19-.85-.34 0-.58.03-.71.07v1.6z" class="roc-color"/></svg>';
                                var preTagLabel = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, tag.split('pfs:label-')[1]).replace(/{{labelContent}}/g, svg);
                            } else {
    							var preTagLabel = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, tag.split('pfs:label-')[1]).replace(/{{labelContent}}/g, tag.split('pfs:label-')[1]);
    							tagLabel += preTagLabel;
                            }
						}
					}
				}
			} else {
				var tagLabel = '';
				if (data.tags) {
					for (var i = data.tags.length - 1; i >= 0; i--) {
						tag = data.tags[i];
						if (tag.indexOf('pfs:label') !== -1) {
							if (tag.indexOf('ROC') !== -1) {
                                var svg = '<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" style="enable-background:new 0 0 612 241.05" version="1.1" viewBox="0 0 612 241.05"><style>.roc-color{fill:#9b6846}</style><path d="M152.4 164.88c1.84-1.62 3.7-3.4 5.71-5.01 2.42-1.95 4.89-3.85 7.45-5.61 4.56-3.14 9.1-6.32 13.83-9.18 5.02-3.04 10.8-.25 11.65 5.56 1.88 12.78 1.5 25.48-1.75 38.03-.21.82-.46 1.63-.69 2.44.12.08.23.15.35.23 1.78-1.79 3.61-3.53 5.34-5.37 1.14-1.22 2.15-2.56 3.21-3.86 9.94-12.23 16.47-26.08 19.68-41.49 3.32-15.95 2.77-31.76-1.7-47.44-2.57-9.01-6.31-17.48-11.36-25.39-3.93-6.16-8.29-11.96-13.69-16.89-3.26-2.98-6.7-5.74-10.05-8.62-4.32-3.73-9.46-6.08-14.43-8.76-7.12-3.85-14.79-5.96-22.65-7.42-1.85-.34-3.87-.17-5.75.11-2.2.33-3.14 1.51-3.31 3.77-.14 1.98-.11 3.97-.11 5.95.02 9.27.06 18.54.1 27.8v1.48c.63-.56 1.03-.87 1.38-1.24 3.77-3.85 7.43-7.83 11.36-11.51 1.36-1.27 3.34-2.39 5.14-2.57 3.28-.33 7.37 2.61 7.84 6.67.32 2.75-.41 5.09-2.4 7.09-3.63 3.64-7.19 7.33-10.76 11.02-4.69 4.86-9.41 9.7-14.02 14.63-1.59 1.7-3.61 2.88-5.68 2.92-1.78.04-4-.89-5.32-2.13-4.85-4.56-9.41-9.43-14.07-14.2-1.31-1.34-2.54-2.76-3.84-4.11-2.78-2.9-5.6-5.75-8.36-8.66-3.74-3.95-2.16-10.38 2.8-12.61 3.47-1.55 6.04-.25 8.33 1.94 3.74 3.59 7.27 7.39 10.9 11.1.37.38.78.73 1.44 1.34V62.2c-.02-10.79-.26-21.59 0-32.38.28-11.67 8.27-19.33 19.96-19.82 6.86-.29 13.34 1.57 19.76 3.56 7.9 2.45 15.37 5.95 22.44 10.21 4.17 2.51 8.17 5.36 11.96 8.41 6.26 5.05 12.04 10.69 16.88 17.11 3.99 5.3 7.78 10.85 10.94 16.68 8.1 14.92 12.51 30.96 13.43 47.94.68 12.51-.6 24.79-3.9 36.88-2.42 8.88-5.85 17.32-10.36 25.35-3.45 6.14-7.29 11.99-11.96 17.27-2.49 2.81-4.97 5.66-7.69 8.24-3.2 3.03-6.5 6.01-10.05 8.61-4.25 3.12-8.78 5.84-13.22 8.68-6.45 4.13-13.66 6.44-20.89 8.73-18.75 5.94-37.64 5.84-56.51 1.03-7.61-1.94-15.09-4.63-22.01-8.48-4.61-2.57-9.13-5.35-13.43-8.39-3.64-2.57-7.08-5.48-10.34-8.53-5.41-5.09-10.35-10.65-14.62-16.74-9.5-13.55-15.92-28.44-18.93-44.74-3.03-16.35-2.62-32.61 1.35-48.77 2.16-8.78 5.29-17.18 9.47-25.22 3.1-5.98 6.67-11.62 10.76-16.98 4.81-6.29 10.07-12.13 16.3-17.03 3.86-3.04 7.92-5.84 11.87-8.77 4.87-3.61 10.4-5.92 15.91-8.3 1.2-.52 2.33-1.21 3.56-1.63 4.39-1.5 7.94.6 9.7 4.75 1.67 3.94-.28 8.38-4.2 10.04-.89.38-1.86.6-2.7 1.05-6.03 3.25-12.19 6.29-17.99 9.92-3.76 2.35-7.14 5.39-10.39 8.45-5.3 5-9.99 10.57-13.99 16.66-6.82 10.39-11.63 21.67-14.2 33.85-2.98 14.15-2.94 28.29.25 42.41 2.02 8.94 5.19 17.42 9.64 25.45 3.42 6.17 7.34 11.96 12.12 17.15 1.47 1.6 2.94 3.22 4.42 4.81.22.24.52.4.82.63-.84-3.81-1.82-7.49-2.46-11.23-1.6-9.44-1.88-18.95-.54-28.44.81-5.75 6.43-8.47 11.51-5.64 3.38 1.88 6.74 3.84 9.94 6 3.96 2.67 7.8 5.51 11.59 8.42 2.73 2.09 5.28 4.42 8.22 6.91-.11-1.41-.17-2.43-.26-3.45-1.14-12.91.52-25.41 5.68-37.34 2.35-5.43 5.3-10.55 9.28-15 1.62-1.81 3.19-3.69 4.99-5.31 3.56-3.21 7.52-3.17 11.12.04 5.23 4.66 9.17 10.31 12.37 16.5 5.26 10.19 7.69 21.07 7.81 32.5.05 3.5.02 7 .02 10.63zm-14.94-9.18c-.49-4.19-.78-8.41-1.51-12.55-1.22-6.88-3.92-13.23-7.78-19.07-1.08-1.63-2.13-1.66-3.1.07-1.87 3.31-3.85 6.62-5.22 10.14-3.65 9.33-4.45 19.08-3.35 28.98 1.14 10.26 4.12 20 8.61 29.28.27.56 1.02 1.31 1.47 1.26.58-.07 1.3-.74 1.58-1.33 1.21-2.63 2.35-5.29 3.39-7.99 3.57-9.27 5.55-18.83 5.91-28.79zm-21.23 59.97c.76.03 1.33-.81.88-2.32-1.49-5.02-3.98-9.56-6.8-13.93-3.41-5.26-7.48-10.02-11.84-14.49-3.26-3.34-6.78-6.43-10.32-9.48-2.47-2.12-5.17-3.97-7.76-5.95-1.12-.86-2.17-1.82-3.34-2.6-1.11-.73-2.17-.14-2.21 1.19-.03.91-.01 1.85.17 2.74.94 4.83 1.6 9.75 2.96 14.46 2.63 9.06 7.49 16.76 15.37 22.27 2.07 1.45 4.22 2.83 6.48 3.94 4.94 2.44 10.25 3.64 16.41 4.17zm60.62-45.64c0-.46.08-.94-.02-1.37-.16-.65-.3-1.62-.72-1.8-.54-.22-1.45.05-2.02.4-.93.58-1.71 1.4-2.56 2.11-3.39 2.83-6.89 5.54-10.14 8.52-3.37 3.08-6.52 6.4-9.71 9.67-4.04 4.13-7.45 8.79-10.27 13.8-2.13 3.78-3.67 7.91-5.34 11.93-.67 1.61.14 2.52 1.81 2.3 5.91-.77 11.6-2.04 16.95-5.02 6.24-3.48 11.25-8.05 14.81-14.14 4.75-8.13 6.65-17.08 7.21-26.4z" class="roc-color"/><path d="M177.57 132.1c-5.06.04-9.91-.88-14.3-3.36-8.01-4.53-12.43-11.57-13.34-20.65-.9-9.02 1.12-17.12 8.05-23.63 3.32-3.12 7.17-4.96 11.46-6 6.81-1.64 13.55-1.3 20.13 1.23 5.73 2.19 10.05 6.13 12.73 11.5 4.12 8.27 4.39 16.91.58 25.38-4.87 10.81-13.85 15.27-25.31 15.53zm-10.15-27.5c.32 1.48.56 2.99.97 4.44 1.97 7.04 10.75 9.36 15.83 4.1 3.24-3.36 3.74-7.51 2.79-11.93-1.29-6.05-7.4-9.33-13.18-7.07-3.99 1.55-6.26 5.35-6.41 10.46zM86.76 109.94c2.91 4.77 5.78 9.44 8.63 14.13.71 1.17 1.4 2.35 2.04 3.56.8 1.5.01 3.03-1.68 3.05-4.84.07-9.69.09-14.52-.05-.73-.02-1.71-.89-2.11-1.62-2.7-5.01-5.27-10.08-7.89-15.13-.27-.53-.59-1.03-.88-1.54l-.39.06c-.03.51-.09 1.01-.09 1.52-.01 4.63 0 9.26-.01 13.9 0 2.31-.58 2.89-2.88 2.9-3.57.01-7.14.01-10.7 0-2.07-.01-2.69-.59-2.69-2.6-.01-15.63-.01-31.25 0-46.88 0-1.73.52-2.36 2.07-2.35 7.69.04 15.39.02 23.08.24 2.2.06 4.45.64 6.55 1.36 6.21 2.11 9.4 6.69 9.99 13.09.6 6.49-1.35 11.85-7.29 15.28-.45.25-.81.7-1.23 1.08zM69.81 92.48v8.37c2.33-.29 4.57-.36 6.69-.9 1.84-.46 2.58-2.11 2.37-4.11-.17-1.61-1.15-2.8-2.93-3.03-1.99-.26-4.02-.23-6.13-.33zM318.17 80.86c2.97 0 5.41-.04 7.85.04.47.02.97.45 1.38.78 2.07 1.62 4.23 3.08 7.01 2.75 4.3-.5 8.79-4.1 8.65-9.71-.65.74-1.14 1.49-1.81 2.02-4.33 3.45-9.1 3.57-13.95 1.42-6.54-2.89-10.73-11.03-8.98-19.19 1.45-6.73 7.8-12.8 15.04-12.55 3.59.12 6.85 1.03 8.93 4.33.07.11.23.15.57.37v-3.7c2.17 0 4.15-.05 6.12.06.31.02.82.78.83 1.2.07 3.77.06 7.53.03 11.3-.04 5.34.18 10.71-.26 16.02-.57 6.9-4.11 12.16-10.73 14.13-6.71 1.99-12.74.79-17.62-4.44-1.18-1.25-1.89-2.94-3.06-4.83zm6.88-17.55c.21.96.42 2.38.85 3.72 1.16 3.66 5.78 6.27 9.54 5.48 4.08-.86 6.78-4.02 7.14-8.61.28-3.56-.8-6.67-3.71-8.89-2.71-2.06-5.72-2.28-8.78-.79-3.6 1.75-4.79 4.92-5.04 9.09zM315.87 143.63c2.67 0 5.11-.05 7.54.04.51.02 1.05.52 1.48.91 3.71 3.32 9.5 3.3 12.87-.23 1.71-1.79 2.64-4.04 2.77-7.03-1.92 2.36-4.03 3.76-6.62 4.39-5.78 1.41-13.62-1.35-17-8.84-3.84-8.5-.65-20.38 10.44-23.29 4.93-1.29 8.69.16 12.1 3.45.17.16.19.46.29.7.15-.1.3-.19.44-.29.05-.98.1-1.96.15-3.05h6.78c.04.33.11.63.11.92-.01 8.6.12 17.21-.08 25.8-.14 6-2.37 10.99-7.83 14.32-5.12 3.13-10.38 3.27-15.55.82-3.52-1.66-6.44-4.39-7.89-8.62zm6.64-18.26v.61c-.03 5.7 5.72 10.36 10.13 9.38 3.73-.83 7.26-4.39 7.46-9.58.16-4.08-3.43-9.03-7.04-9.79-5.74-1.2-10.63 3.96-10.55 9.38zM275.34 98.88c7.4.2 13.23 3.62 17.18 9.67 5.37 8.23 4.21 18.27-.95 25.34-6.32 8.67-21.57 11.78-31.23 1.86-6.67-6.86-7.85-16.52-3.84-24.91 2.07-4.33 5.38-7.24 9.47-9.59 2.94-1.71 6.05-2.19 9.37-2.37zm13.29 20.29c.07-3.81-2.23-7.76-6.04-10.69-5.15-3.96-13.02-2.53-16.56 1.49-3.3 3.75-4.71 7.79-4.24 12.69.75 7.71 9.66 14.59 17.55 11.44 5.53-2.21 9.51-7.61 9.29-14.93zM256.06 37.3c5.08 0 10.03-.15 14.95.03 8.5.32 13.09 8.99 11.17 16.08-1.29 4.79-3.86 8.37-8.99 9.55-.29.07-.56.21-.97.36 3.53 5 7.01 9.92 10.67 15.11-.75.04-1.27.09-1.78.09-1.48.01-2.98-.15-4.43.04-2.13.28-3.33-.63-4.38-2.39-1.58-2.66-3.42-5.17-5.12-7.75-1.17-1.77-2.3-3.57-3.77-5.29v15.25h-7.36c.01-13.65.01-27.31.01-41.08zm7.35 7.02v12.32c2.37 0 4.67.27 6.89-.06 3.14-.48 4.89-2.81 4.92-5.87.03-3.04-1.75-5.5-4.78-6.01-2.26-.39-4.62-.27-7.03-.38zM466.7 175.2v-12.52h7.06v41.16h-6.36c-.06-1.07-.13-2.19-.19-3.31-1.45 1.13-2.67 2.54-4.21 3.2-4.78 2.03-9.34 1.51-13.63-1.64-6.46-4.74-8.11-11.13-6.36-18.51 2.01-8.44 10.4-13.43 18.49-11.28.92.24 1.82.65 2.66 1.11.79.44 1.49 1.04 2.54 1.79zm.53 13.08c-.03-5.37-3.9-9.59-8.81-9.61-4.86-.02-8.95 4.33-8.85 9.58.1 5.2 3.56 9.73 8.82 9.78 5.29.04 8.73-4.74 8.84-9.75zM293.53 174.21c-2.54 0-5.09.07-7.62-.05-.58-.03-1.19-.68-1.67-1.16-6.58-6.42-16.56-5.05-20.79 3.06-2.98 5.71-2.28 12.6 2.66 17.45 4.53 4.45 10.32 5.36 15.23 2.2 1.08-.7 1.87-1.84 2.91-2.63.59-.45 1.39-.82 2.11-.86 2.33-.11 4.67-.04 7.14-.04-.84 2.9-2.53 5.08-4.64 6.95-6.05 5.38-13.02 7.33-20.63 4.31-10.13-4.01-15.81-14.27-13.33-25.22 2.15-9.5 9.85-16.38 19.9-16.47 5.69-.05 10.77 1.84 14.75 5.97 1.69 1.76 2.89 3.98 4.31 5.99-.12.18-.23.34-.33.5zM439.54 191.59h-23.09c.61 3.23 3.15 5.65 6.44 6.3 3.33.66 6.5-.56 8.21-3.12.2-.31.51-.76.78-.77 2.32-.06 4.65-.04 7.16-.04-.78 2.69-2.25 4.63-4.02 6.43-6.23 6.32-14.02 5.22-18.19 2.54-7.12-4.56-9.67-11.53-7.32-19.72 1.66-5.78 5.43-9.85 11.64-11.05 5.15-1 9.99-.11 13.75 3.65 4.26 4.27 5.94 9.55 4.64 15.78zm-7.01-6.18c-.81-4.44-3.98-6.92-8.38-6.73-4.15.18-7.53 3.06-7.84 6.73h16.22zM492.82 51.02v-3.59c2.09 0 4.02-.05 5.94.06.25.01.66.78.67 1.21.06 3.21.03 6.41.03 9.62V78.42h-6.63v-3.51c-2.91 2.91-6.2 4.4-10.03 4.58-3.44.16-6.64-.76-9.22-3.05-3.75-3.33-5.59-7.63-5.79-12.67-.22-5.57 1.72-10.2 5.68-14.1 4.22-4.16 13.67-4.24 17.74-.07.47.48.86 1.02 1.29 1.54.1-.03.21-.08.32-.12zm-.18 11.74c-.2-2.53-.7-5.03-2.69-6.99-4.44-4.38-11.85-2.78-14.04 3.05-1.78 4.74-.85 9.38 2.51 11.94 2.83 2.16 5.97 2.56 9.2 1.03 3.74-1.77 4.83-5.11 5.02-9.03z" class="roc-color"/><path d="M325.87 191.54h-22.86c.12 3.04 3.3 6.02 6.81 6.4 3.27.35 6.05-.51 7.93-3.45.17-.27.6-.52.92-.53 2.18-.05 4.37-.02 6.63-.02.02.29.09.5.03.66-3.48 8.46-12.82 13.58-21.9 8.37-10.15-5.83-9.79-17.92-4.96-24.97 4.73-6.9 16.72-8.53 23.27-1.9 3.78 3.79 5.72 10.77 4.13 15.44zm-6.94-6.13c-.37-4.04-3.71-6.8-8.04-6.74-4.27.06-7.87 3.04-8.09 6.74h16.13zM425.99 66.19c.05.45 0 .78.12 1.04 1.22 2.89 3.38 4.68 6.46 5.25 2.95.54 5.65-.05 7.59-2.47.78-.97 1.53-1.28 2.69-1.23 1.82.08 3.65.02 5.62.02-.12.48-.16.82-.29 1.12-4.63 10.3-16.09 12.35-23.67 6.35-5.53-4.38-7.3-10.5-5.67-17.41 2.41-10.2 12.45-15.36 22.04-10.9 6.06 2.82 9.65 10.1 8.46 17.29-.17 1.04-.88.92-1.59.92h-20.04c-.54.02-1.09.02-1.72.02zm16.04-5.83c-.28-4.26-3.38-6.94-7.79-7.06-3.67-.1-7.98 2.29-8.33 7.06h16.12zM568.82 66.19c.4 3.39 3.95 6.31 7.7 6.46 2.81.11 5.21-.75 6.92-3.13.21-.3.6-.66.92-.67 2.28-.06 4.55-.03 7.02-.03-.22.61-.33 1.04-.52 1.43-4.84 10.15-16.11 11.86-23.43 6.11-5.53-4.34-7.39-10.4-5.8-17.35 2.31-10.06 11.91-15.17 21.37-11.37 6.34 2.55 10.5 10.37 9.1 17.75-.05.24-.16.47-.27.8h-23.01zm16.07-5.8c-.54-4.75-3.8-7.33-8.72-7.04-4.07.24-7.45 3.44-7.38 7.04h16.1zM313.53 68.81c-4.05 11.17-16.5 13.88-24.37 7.2-8.52-7.23-6.8-19.09-.94-25.19 4.6-4.79 13.89-5.8 19.24-2 5.43 3.86 8.39 10.74 6.54 17.36h-23.09c.18.67.23 1.22.46 1.66 3.31 6.37 11.53 5.96 14.25 1.7.21-.33.69-.69 1.05-.7 2.22-.06 4.45-.03 6.86-.03zm-6.47-8.43c-.51-4.76-3.91-7.39-8.88-7.02-3.96.29-7.34 3.58-7.2 7.02h16.08zM361.2 66.19c.03.49-.02.76.07.98 1.24 2.95 3.43 4.78 6.57 5.33 3.01.53 5.71-.16 7.67-2.65.6-.77 1.18-1.1 2.15-1.06 1.93.08 3.87.02 5.94.02-.08.44-.08.79-.21 1.08-4.72 10.53-16.39 12.36-23.89 6.24-5.36-4.37-7.07-10.44-5.48-17.21 2.31-9.85 11.72-15.17 21.45-11.25 6.29 2.54 10.41 10.47 9.05 17.67-.19 1.01-.84.84-1.47.84-6.27.01-12.54 0-18.81 0-.95.01-1.91.01-3.04.01zm-.15-5.86h16.2c-.4-4.19-3.32-6.89-7.49-7-4.74-.13-8.07 2.52-8.71 7zM375.73 113.94v-3.52h6.51v30.59h-6.41c-.06-1.03-.12-2.06-.17-3.09-1.51.94-2.85 1.95-4.33 2.68-6.47 3.16-14.46.98-17.96-5.09-3.02-5.25-3.55-10.84-1.45-16.62 1.69-4.65 5.03-7.41 9.62-9.08 5.32-1.94 9.46.05 13.36 3.34.18.16.35.33.83.79zm-.2 11.73c.27-4.2-2.73-8.25-5.66-9.28-6.35-2.24-11.31 2.35-11.93 8.45-.6 5.87 3.24 9.43 7.18 10.44 5.27 1.37 10.68-3.8 10.41-9.61zM395.45 78.45h-7.14V47.57h6.43c.07.66.14 1.34.19 1.86 1.79-.89 3.5-2.13 5.39-2.6 6.45-1.58 12.75 2 14.13 9.46.15.8.28 1.62.28 2.42.02 6.51.01 13.02.01 19.68h-6.99c-.03-.55-.07-1.13-.08-1.72-.04-5.29-.03-10.59-.14-15.88-.03-1.25-.29-2.54-.7-3.73-.91-2.66-2.92-3.91-5.63-3.73-2.6.18-4.91 2.14-5.35 4.69-.25 1.45-.37 2.93-.39 4.4-.05 4.73-.02 9.47-.02 14.21.01.56.01 1.11.01 1.82zM414.71 141.07h-7.43c-.03-.57-.07-1.11-.07-1.64-.01-4.94.01-9.88-.01-14.81-.01-2.27-.6-4.35-1.61-6.43-1.37-2.84-6.6-3.16-8.74-.28-1.38 1.86-1.83 3.95-1.86 6.17-.06 4.99-.04 9.98-.06 14.97V141h-6.98v-30.57h6.38c.06.66.13 1.31.17 1.81 1.93-.94 3.79-2.04 5.79-2.73 1.27-.44 2.76-.39 4.14-.31.81.04 1.6.56 2.4.87 3.9 1.54 6.69 4.25 6.99 8.49.53 7.43.62 14.89.89 22.51zM460.81 120.48c-2.52 0-5.02.14-7.47-.09-.66-.06-1.24-1.2-1.81-1.89-2.89-3.51-8.19-3.54-11.33-.21-3.21 3.41-3.64 7.25-2.13 11.45.98 2.72 3.14 4.49 5.72 5.32 3.56 1.15 5.38.36 8.35-3.01.65-.74 1.23-1.04 2.18-1.02 2.13.06 4.27.02 6.57.02-1.08 3.49-2.91 6.25-5.8 8.27-6.89 4.81-17.21 3.1-21.93-3.85-6.55-9.64-2.27-22.75 9.3-25.94 6.68-1.84 16.69 3.2 18.32 10.32.03.14.01.29.03.63zM532.61 47.42c2.56 0 4.84-.06 7.11.06.39.02.92.7 1.09 1.18 2.21 6.23 4.36 12.48 6.53 18.72.06.18.19.34.41.73 1.13-3.39 2.21-6.58 3.26-9.77 1.1-3.33 2.17-6.67 3.31-9.98.13-.38.63-.88.98-.89 2.28-.08 4.57-.04 7.07-.04-.42 1.25-.74 2.35-1.15 3.41-3.03 7.71-6.09 15.41-9.14 23.12-.37.94-.81 1.88-1.03 2.86-.33 1.52-1.25 1.78-2.65 1.75-3.8-.08-3.72-.06-5.09-3.68-1.81-4.81-3.78-9.55-5.65-14.33-1.66-4.26-3.28-8.54-5.05-13.14zM378.76 172.85c.48 0 .99.13 1.38-.03.41-.17.89-.55 1.01-.94.32-1.06.42-2.19.68-3.27 1.12-4.56 6.27-7.72 10.93-6.65v7.17c-2.44-.11-4.42.47-4.39 3.64h4.01v6.7h-4.12v24.43h-7.07v-24.04c-.29-.19-.37-.28-.46-.29-2.21-.23-2.22-.23-2.21-2.57 0-1.22.02-2.44.04-3.66.01-.11.08-.2.2-.49zM351.13 179.47h-3.45v-6.54c1.05-.05 2.1-.1 3.35-.16v-10.11h7.15v10.13h4.27v6.62h-4.18v24.42h-7.14v-24.36zM514.94 47.41h4.2v6.7c-.84 0-1.69.07-2.52-.02-1.25-.13-1.67.3-1.65 1.6.06 6.92.03 13.84.03 20.77v1.95h-7.08V54.23c-1.25-.07-2.33-.14-3.6-.22 0-1.99-.03-3.91.04-5.83.01-.26.54-.68.86-.72.79-.11 1.61-.03 2.58-.03V37.32h7.15c-.01 3.29-.01 6.57-.01 10.09zM336.95 172.95c.05.73.09 1.37.17 2.5 1.71-2.7 3.92-3.79 6.85-3.61v7.08c-.26.06-.58.16-.92.23-3.83.79-5.43 2.7-5.47 6.71-.05 5.4-.01 10.79-.01 16.19v1.84h-7.11v-30.93c2.2-.01 4.31-.01 6.49-.01zM460.01 47.42c.05.91.08 1.61.14 2.81 1.72-2.77 3.9-3.99 6.93-3.76v7.07c-.13.05-.26.13-.4.16-4.24.7-5.92 2.59-5.96 6.88-.05 5.34-.01 10.68-.01 16.02v1.8h-7.22v-1.64c0-9.2.03-18.41-.03-27.61-.01-1.45.44-1.85 1.81-1.75 1.51.1 3.04.02 4.74.02zM307.34 141.03h-7.09V110.4h6.38c.07.67.13 1.35.23 2.27 1.88-2.17 3.85-3.83 6.89-3.65v7.06c-.2.06-.43.19-.67.2-3.74.13-5.7 3.66-5.7 6.39-.01 5.5-.02 10.99-.04 16.49v1.87zM405.11 203.88h-7.02v-30.95h7.02v30.95zM366.69 203.87v-30.92h6.96v30.92h-6.96zM530.64 78.45h-7.1V47.43c2.14 0 4.27-.03 6.39.04.25.01.65.58.68.92.09 1.16.04 2.34.04 3.5v24.4c-.01.66-.01 1.32-.01 2.16zM426.16 141.05h-6.96v-30.67h6.96v30.67zM405.12 169.38h-7.01v-6.68h7.01v6.68zM366.67 169.33v-6.66h6.97v6.66h-6.97zM419.22 99.71c2.07 0 4.14-.03 6.21.04.28.01.77.51.78.8.07 1.92.04 3.85.04 5.89h-7.03v-6.73zM523.52 43.94v-6.6h7.01v6.6h-7.01zM491.45 166.1c0 3.16-2.48 5.64-5.71 5.64-3.2 0-5.75-2.48-5.75-5.64 0-3.09 2.55-5.58 5.75-5.58 3.23.01 5.71 2.49 5.71 5.58zm-10.03 0c0 2.48 1.84 4.45 4.35 4.45 2.45 0 4.25-1.97 4.25-4.42 0-2.48-1.8-4.49-4.28-4.49-2.49.01-4.32 2.02-4.32 4.46zm3.43 2.93h-1.29v-5.58c.51-.1 1.22-.17 2.14-.17 1.05 0 1.53.17 1.94.41.31.24.54.68.54 1.22 0 .61-.48 1.09-1.16 1.29v.07c.54.2.85.61 1.02 1.36.17.85.27 1.19.41 1.39h-1.39c-.17-.2-.27-.71-.44-1.36-.1-.61-.44-.88-1.16-.88h-.61v2.25zm.04-3.16h.61c.71 0 1.29-.24 1.29-.82 0-.51-.37-.85-1.19-.85-.34 0-.58.03-.71.07v1.6z" class="roc-color"/></svg>';
                                var preTagLabel = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, tag.split('pfs:label-')[1]).replace(/{{labelContent}}/g, svg);
    							tagLabel += preTagLabel;
                            } else {
    							var preTagLabel = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, tag.split('pfs:label-')[1]).replace(/{{labelContent}}/g, tag.split('pfs:label-')[1]);
    							tagLabel += preTagLabel;
                            }
							break;
						}
					}
				}
			}
			return tagLabel;
		} else {
			return '';
		}
	}

	// Build Color Swatches
	function buildColorSwatches(data) {
		var colorSwatchesHtml = '';
		if (boostPFSThemeConfig.custom.display_item_swatch) {
			colorSwatchesHtml += '<ul class="boost-pfs-filter-item-swatch">';
			for (var index = 0; index < data.options.length; index++) {
				var option = data['options'][index].toLowerCase();
				if (option == 'color') {
					var colorlist = '';
					var color = '';
					var totalVariants = 0;
					for (var k = 0; k < data.variants.length; k++) {
						var variant = data['variants'][k];
						color = variant['options'][index];
						if (colorlist.indexOf(color) == -1) {
							if (totalVariants < 4) {
								var text = Utils.slugify(color);
								var border = text == 'white' ? 'border: 1px solid #cbcbcb;' : '';
								var backgroundImage = Utils.optimizeImage(variant.image, '50x');
								var backgroundImageURL = '';
								var dataImg = '';
								var dataColor = '#fff';
								dataColors = variant.option_color.toLowerCase().split(' ');
								var i = dataColors.length;
								if (dataColors[i] !== '' && dataColors[i] !== 'colors') {
									dataColor = dataColors[i];
								}

								if (variant.image !== null) {
									dataImg = "data-img='" + Utils.optimizeImage(variant.image, '300x') + " 300w'";
								}

								// if (variant.image !== null) {
								// 	dataImg = "data-img='" + Utils.optimizeImage(variant.image) + "'";
								// } else {
								// 	var _file = variant.option_color.toLowerCase().replace(/ /g, '-');
								// 	backgroundImage = boostPFSAppConfig.general.file_url.split('?')[0] + 'color-' + _file + '.png';
								// }
								var _file = '';
								for (var i = 0; i < variant.merged_options.length; i++) {
									var color = variant.merged_options[i];

									if (color.indexOf('color') != -1) {
										_file = color
											.toLowerCase()
											.replace(/: /g, '-')
											.replace(/:/g, '-')
											.replace(/ /g, '-')
											.replace(/color-/g, '');
									}
								}

								if (boostPFSThemeConfig.custom.swatch_color_display_type == 'swatch_color_display_type_image_color') {
									backgroundImage =
										boostPFSAppConfig.general.file_url.split('?')[0] +
										'color-' +
										_file +
										'.png?v=' +
										boostPFSAppConfig.general.file_url.split('?')[1];
									backgroundImageURL = 'url(' + backgroundImage + ')';
								} else if (boostPFSThemeConfig.custom.swatch_color_display_type == 'swatch_color_display_type_image_product') {
									backgroundImage = Utils.optimizeImage(variant.image, '50x');
									backgroundImageURL = 'url(' + backgroundImage + ')';
								} else {
									backgroundImageURL = 'none';
								}
								var colorName = color.split(':').pop();
								colorSwatchesHtml += '<li>';
								colorSwatchesHtml += '<div class="tooltip">' + colorName + '</div>';
								colorSwatchesHtml +=
									'<span tabindex="0" aria-label="' +
									colorName +
									'" style="background-color: ' +
									dataColor +
									'; background-image: ' +
									backgroundImageURL +
									';" ' +
									dataImg +
									'></span>';

								//colorSwatchesHtml += '<label style="' + border + 'background-image: url(' + Utils.optimizeImage(variant.image, '24x') + ');"' + if (variant.image !== null){ + 'data-img="' + Utils.optimizeImage(variant.image) + '"' + } '></label>';
								colorSwatchesHtml += '</li>';
							}
							var templist = colorlist + color + ' ';
							colorlist = templist;

							totalVariants++;
						}
					}
					// if (totalVariants == 1) {
					// colorSwatchesHtml = '<ul class="boost-pfs-filter-item-swatch">';
					// }
					if (totalVariants > 4) {
						colorSwatchesHtml += '<li class="boost-pfs-filter-item-swatch-more">';
						colorSwatchesHtml += '<a href="{{itemUrl}}" title="More Color">+' + (totalVariants - 4) + '</a>';
						colorSwatchesHtml += '</li>';
						totalVariants = 0;
					}
				}
			}
			colorSwatchesHtml += '</ul>';
		}
		return colorSwatchesHtml;
	}

	// Build Color Swatches
	function eventColorSwatches(event) {
		jQ('.boost-pfs-filter-item-swatch li span').each(function() {
			var img = jQ(this)
				.parents('.boost-pfs-filter-product-item-inner')
				.find('.boost-pfs-filter-product-item-main-image');
			if (event == 'hover') {
				jQ(this).hover(function() {
					var newImage = jQ(this).data('img');
					img.attr('srcset', newImage);
				});
			}
			if (event == 'click') {
				jQ(this).click(function() {
					var newImage = jQ(this).data('img');
					img.attr('srcset', newImage);
				});
			}
			jQ(this).focus(function() {
				if (jQ('body').hasClass('boost-pfs-ada')) {
					var newImage = jQ(this).data('img');
					img.attr('srcset', newImage);
				}
			});
		});
	}

	/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
	/************************** BUILD TOOLBAR **************************/
	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
		// If it has only one page, clear Pagination
		if (totalPage <= 1) {
			return '';
		}

		var paginationHtml = boostPFSTemplate.paginateHtml;
		// Build Previous
		var previousHtml = currentPage > 1 ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
		// Build Next
		var nextHtml = currentPage < totalPage ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
		// Create page items array
		var beforeCurrentPageArr = [];
		for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
			beforeCurrentPageArr.unshift(iBefore);
		}
		if (currentPage - 4 > 0) {
			beforeCurrentPageArr.unshift('...');
		}
		if (currentPage - 4 >= 0) {
			beforeCurrentPageArr.unshift(1);
		}
		beforeCurrentPageArr.push(currentPage);
		var afterCurrentPageArr = [];
		for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
			afterCurrentPageArr.push(iAfter);
		}
		if (currentPage + 3 < totalPage) {
			afterCurrentPageArr.push('...');
		}
		if (currentPage + 3 <= totalPage) {
			afterCurrentPageArr.push(totalPage);
		}
		// Build page items
		var pageItemsHtml = '';
		var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
		for (var iPage = 0; iPage < pageArr.length; iPage++) {
			if (pageArr[iPage] == '...') {
				pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
			} else {
				pageItemsHtml += pageArr[iPage] == currentPage ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
			}
			pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
			pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
		}
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
		return paginationHtml;
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function() {
		var html = '';
		if (boostPFSThemeConfig.custom.show_sorting && boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				var paramSort = Globals.queryParams.sort || '';
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					activeClass = '';
					if (paramSort == k) {
						activeClass = 'boost-pfs-filter-sort-item-active';
					}
					sortingItemsHtml += '<li data-sort-type="'+ k +'"><a href="#" data-sort="' + k + '" class="' + activeClass + '">' + sortingArr[k] + '</a></li>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		return html;
	};

	ProductSorting.prototype.render = function() {
		jQ(Selector.topSorting).html(this.compileTemplate());

		if (jQ('.boost-pfs-filter-custom-sorting').hasClass('boost-pfs-filter-sort-active')) {
			jQ('.boost-pfs-filter-custom-sorting').toggleClass('boost-pfs-filter-sort-active');
		}

		var labelSort = '';
		var paramSort = Globals.queryParams.sort || '';
		if (paramSort.length > 0) {
			var labelHandle = 'sorting_' + paramSort.replace(/\-/g, '_');
			labelSort = Labels[labelHandle];
		} else {
			labelSort = Labels.sorting_heading;
		}

		jQ('.boost-pfs-filter-custom-sorting button span span').text(labelSort);
	};

	// Build Sorting event
	ProductSorting.prototype.bindEvents = function() {
		var _this = this;
		jQ('.boost-pfs-filter-filter-dropdown a').click(function(e) {
			e.preventDefault();
			FilterApi.setParam('sort', jQ(this).data('sort'));
			FilterApi.setParam('page', 1);
			FilterApi.applyFilter('sort');
		});

		jQ('.boost-pfs-filter-custom-sorting > button').click(function() {
			if (!jQ('.boost-pfs-filter-filter-dropdown').is(':animated')) {
				jQ('.boost-pfs-filter-filter-dropdown')
					.toggle()
					.parent()
					.toggleClass('boost-pfs-filter-sort-active');
			}
		});

		jQ(Selector.filterTreeMobileButton).click(function() {
			jQ('.boost-pfs-filter-top-sorting-mobile .boost-pfs-filter-filter-dropdown').hide();
		});
	};
	// For Toolbar - Build Display type
	ProductDisplayType.prototype.compileTemplate = function() {
		var itemHtml = '<span>' + boostPFSThemeConfig.label.toolbar_viewas + '</span>';
		if (boostPFSThemeConfig.custom.product_item_type == 'grid') {
			itemHtml +=
				'<a href="' +
				Utils.buildToolbarLink('display', 'list', 'grid') +
				'" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"></span></a>';
			itemHtml +=
				'<a href="' +
				Utils.buildToolbarLink('display', 'grid', 'list') +
				'" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"></span></a>';
		} else {
			itemHtml +=
				'<a href="' +
				Utils.buildToolbarLink('display', 'grid', 'list') +
				'" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"></span></a>';
			itemHtml +=
				'<a href="' +
				Utils.buildToolbarLink('display', 'list', 'grid') +
				'" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"></span></a>';
		}

		itemHtml = itemHtml.replace(/{{class.productDisplayType}}/g, Class.productDisplayType);

		return itemHtml;
	};

	// Build Show Limit
	ProductLimit.prototype.compileTemplate = function() {
		var html = '';
		if (boostPFSThemeConfig.custom.show_limit && boostPFSTemplate.hasOwnProperty('showLimitHtml')) {
			var numberList = Settings.getSettingValue('general.showLimitList');
			if (numberList != '') {
				// Build content
				var showLimitItemsHtml = '';
				var arr = numberList.split(',');
				for (var k in sortingArr) {
					showLimitItemsHtml += '<option value="' + arr[k].trim() + '">' + arr[k].trim() + '</option>';
				}
				html = boostPFSTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml);
			}
		}
		return html;
	};
	// Build Breadcrumb
	Breadcrumb.prototype.compileTemplate = function(colData) {
		if (!colData) colData = this.collectionData;
		var breadcrumbItemsHtml = '';
		if (boostPFSTemplate.hasOwnProperty('breadcrumbHtml')) {
			if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
				var colInfo = colData.collection;
				if (typeof this.collectionTags !== 'undefined' && this.collectionTags !== null) {
					breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemLink
						.replace(/{{itemLink}}/g, '/collections/' + colInfo.handle)
						.replace(/{{itemTitle}}/g, colInfo.title);
					breadcrumbItemsHtml += ' {{breadcrumbDivider}} ';
					breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, this.collectionTags[0]);
				} else {
					breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, colInfo.title);
				}
			} else {
				breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(
					/{{itemTitle}}/g,
					Settings.getSettingValue('label.defaultCollectionHeader')
				);
			}
		}
		return breadcrumbItemsHtml;
	};

	/************************** END BUILD TOOLBAR **************************/
	function matchHeightImage() {
		// jQ('.boost-pfs-filter-product-item-main-image').load(function() {
		// 	var imageContainer = jQ(this).parent();
		// 	imageContainer.css('width', '100%').css('height', jQ(this).height());
		// }).each(function() {
		// 	if (this.complete) jQ(this).load();
		// });
	}

	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function(data) {
		if (!data) data = this.data;

		// Intergrate Review Shopify
		if (window.SPR && boostPFSThemeConfig.custom.show_product_review) {
			window.SPR.initDomEls();
			window.SPR.loadBadges();
		}
	};

	// Build additional elements
	Filter.prototype.afterRender = function(data) {
		if (!data) data = this.data;

		var totalProduct = data.total_product + '<span> ' + boostPFSThemeConfig.label.products_count_multi + '</span>';
		if (data.total_product == 1) {
			totalProduct = data.total_product + '<span> ' + boostPFSThemeConfig.label.products_count_single + '</span>';
		}
		if (jQ('.boost-pfs-filter-refine-by-wrapper-v').length && !jQ('.boost-pfs-filter-refine-by-wrapper-v').html().length) {
			totalProduct = '';
		}

		jQ('.boost-pfs-filter-total-product').html(totalProduct);
		matchHeightImage();
		jQ(window).resize(function() {
			matchHeightImage();
		});

		jQ('body')
			.find('.boost-pfs-filter-skeleton-button')
			.remove();

		// Prevent double tap on iOS
		var isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
		if (isiOS) {
			Utils.isMobile() &&
				jQ('.boost-pfs-filter-product-item')
					.find('a')
					.on('touchstart', function() {
						isScrolling = !1;
					})
					.on('touchmove', function() {
						isScrolling = !0;
					})
					.on('touchend', function() {
						isScrolling || (window.location = jQ(this).attr('href'));
					});
		}

		// Build Image Swap
		swapImage(data);

		// Build Equal Height
		if (Globals.queryParams.display !== 'list') {
			equalHeight(data);
		}
		jQ(window).resize(function() {
			if (Globals.queryParams.display !== 'list') {
				equalHeight(data);
			}
		});

		// Build Event Color Swatch
		if (boostPFSThemeConfig.custom.swatch_color_event_change_image != 'none') {
			eventColorSwatches(boostPFSThemeConfig.custom.swatch_color_event_change_image);
		}

		// Integrate Stamped.io Reviews
		var self = this;
		if (typeof StampedFn !== 'undefined' && typeof StampedFn.loadBadges == 'function') {
			StampedFn.loadBadges();
		}
	};

	ProductListPlaceholder.prototype.render = function() {
		// Set limit number for product skeleton
		var placeholderLimit = this.settings.productsPerRow || this.settings.placeholderProductPerRow;
		// Build placeholder items
		var placeholderItem = this.compileTemplate();
		this.$element = [];
		for (var i = 0; i < placeholderLimit; i++) {
			this.$element.push(jQ(placeholderItem));
		}
		// Show placeholder before send filter request OR hide it after get filter data
		if (!this.isFetchedProductData) {
			this.setShow();
		} else {
			this.setHide();
		}
	};

	ProductListPlaceholder.prototype.compileTemplateExtra = function() {
		var display = Globals.queryParams.display;
		switch (display) {
			case 'list':
				//Todo: Build placeholder for List mode
				var template = boostPFSTemplate.productListPlaceholderHtml;
				var imgRatioSetting = parseFloat(this.settings.placeholderImageRatio);
				var imgRatio = imgRatioSetting > 0 ? imgRatioSetting : 1.4; // It mean w1:h1.4
				/**
				 * Set product class for product skeleton (to set column, style, etc.)
				 * - If had defined product_grid_class in boostPFSThemeConfig => use this config ELSE use our setting
				 */
				break;
		}
		return template
			.replace(/{{class.filterProductSkeleton}}/g, Class.filterProductSkeleton)
			.replace(/{{class.filterSkeleton}}/g, Class.filterSkeleton)
			.replace(/{{class.filterSkeletonText}}/g, Class.filterSkeletonText)
			.replace(/{{paddingTop}}/g, imgRatio * 100);
	};

	/* Prevent conflict with theme vendor js */
	Array.prototype.insert = function(a, b) {};

	/* Math qual Height */
	function equalHeight(data) {
		var equal_i = -1;
		var equal_els = [];
		var equal_element = null;

		// Equal Height Title
		jQ('.boost-pfs-filter-product-item').each(function(i, element) {
			var offsetTop = jQ(element).offset().top;
			if (!equal_element || equal_element.offset().top !== offsetTop) {
				equal_element = jQ(element);
				equal_i++;
			}

			if (!equal_els[equal_i]) {
				equal_els[equal_i] = [];
			}
			equal_els[equal_i].push(element);
		});

		for (var i = 0; i < equal_els.length; i++) {
			var max = 0;
			var maxRatio = 0;
			var iLength = equal_els[i].length;

			for (var j = 0; j < equal_els[i].length; j++) {
				var item = equal_els[i][j];
				var height = jQ(item)
					.find('.boost-pfs-filter-product-bottom-inner')
					.height();
				max = Math.max(max, height);
			}

			jQ(equal_els[i])
				.find('.boost-pfs-filter-product-bottom-inner')
				.css({ 'min-height': max });
		}

		var equal_height = boostPFSFilterConfig.general.equal_height;

		if (equal_height != 'false') {
			var cropImagePosition = boostPFSFilterConfig.general.cropImagePossitionEqualHeight;

			var widthImage = jQ('.boost-pfs-filter-product-item').width();
			var indexData = 0;

			// For Ratio
			if (equal_height != 'false' && equal_height != 'auto') {
				var heightImage = 0;
				var widthImage = jQ('.boost-pfs-filter-product-item').width();
				if (equal_height != 'false' && equal_height != 'auto') {
					var ratioWidthHeight = boostPFSThemeConfig.custom.equal_height;
				} else {
					var ratioWidthHeight = '';
				}

				var ratioWidthHeightOther = boostPFSThemeConfig.custom.ratio_width_height_other;
				if (ratioWidthHeightOther == '' && ratioWidthHeight == '') {
					return null;
				} else {
					if (ratioWidthHeightOther == '') {
						ratioWidthHeight = ratioWidthHeight.split(':');
						ratioWidthHeight = parseInt(ratioWidthHeight[1]) / parseInt(ratioWidthHeight[0]);
						heightImage = widthImage * ratioWidthHeight;
					} else if (ratioWidthHeightOther != '') {
						ratioWidthHeightOther = ratioWidthHeightOther.split(':');
						ratioWidthHeightOther = parseInt(ratioWidthHeightOther[1]) / parseInt(ratioWidthHeightOther[0]);
						heightImage = widthImage * ratioWidthHeightOther;
					}
				}
				jQ('.boost-pfs-filter-product-item-image-link')
					.css({ 'padding-top': heightImage + 'px' })
					.addClass('boost-pfs-filter-crop-image-position-' + cropImagePosition);
			}
		}
	}

	// Swap Image
	function swapImage(data) {
		if (!Utils.isMobile()) {
			if (boostPFSThemeConfig.custom.active_image_swap) {
				var thumbUrl = Utils.getFeaturedImage(images, '260x');

				jQ('.boost-pfs-filter-product-item').each(function() {
					var flipImageUrl = jQ(this)
						.find('.boost-pfs-filter-product-item-main-image')
						.data('img-flip');
					var flipImageSrcset = jQ(this)
						.find('.boost-pfs-filter-product-item-main-image')
						.data('img-flip-srcset');
					var flipImageAlt =
						jQ(this)
							.find('.boost-pfs-filter-product-item-main-image')
							.attr('alt') + ' second';

					var html =
						'<img class="boost-pfs-filter-product-item-flip-image lazyload Image--lazyLoad"' +
						'data-srcset="' +
						flipImageSrcset +
						'" ' +
						'data-src="' +
						flipImageUrl +
						'" ' +
						'data-widths="[180, 260, 360, 480]" ' +
						'data-sizes="auto" ' +
						'src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" ' +
						'alt="' +
						flipImageAlt +
						'" />';
					jQ(this)
						.find('.boost-pfs-filter-product-item-image-link')
						.prepend(html);
				});
			}
		}
	}
})();

// Add to Cart Fix on Filter and Pagination
(function() {

    jQ('.collection-quick-add .quick-add-options input[type="radio"]').change(function() {
          if (jQ(this).is(':checked')) {
            var id = jQ(this).val();
            var price = jQ(this).attr('data-price');
            jQ(this).closest('.boost-pfs-filter-product-bottom').find('.quick-add-select').val(id);
            jQ(this).closest('.boost-pfs-filter-product-bottom').prev().find('.js-quick-add-price').html(price);
          }
        });


    jQ('.collection-quick-add').each(function(){
          var btn = jQ(this).find('button');
          btn.click(function(e){
            var productID = jQ(this).closest('.collection-quick-add').find('.quick-add-select').val();
            e.preventDefault();
            jQ.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: {
                quantity: 1,
                id: productID
              },
                dataType: 'json'
             });
          })
      });
  
  ProductList.prototype.afterRender = function() {
    
       jQ('.collection-quick-add .quick-add-options input[type="radio"]').change(function() {
          if (jQ(this).is(':checked')) {
            var id = jQ(this).val();
            var price = jQ(this).attr('data-price');
            jQ(this).closest('.boost-pfs-filter-product-bottom').find('.quick-add-select').val(id);
            jQ(this).closest('.boost-pfs-filter-product-bottom').prev().find('.js-quick-add-price').html(price);
          }
        });


    jQ('.collection-quick-add').each(function(){
          var btn = jQ(this).find('button');
          btn.click(function(e){
            var productID = jQ(this).closest('.collection-quick-add').find('.quick-add-select').val();
            e.preventDefault();
            jQ.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: {
                quantity: 1,
                id: productID
              },
                dataType: 'json'
             });
          })
      });
  
  }
})();